import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import {
    Alert,
    Button,
    Checkbox,
    Chip,
    FormControl, FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput, Pagination,
    Select,
    Slide,
    Snackbar,
    TextField,
    Tooltip,
} from "@mui/material";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import {AiOutlinePlus, AiOutlineSearch} from "react-icons/ai";
import {MdClose, MdDelete, MdOutlineCleaningServices} from "react-icons/md";
import {
    FaExpand,
    FaFileAlt,
    FaFileExcel,
    FaFilter,
    FaMapMarkedAlt,
    FaSort,
    FaSortDown,
    FaSortUp
} from "react-icons/fa";
import CaseStatus, {
    findMatchingInternalStatusesById,
    findMatchingStatusesById,
    findStatusTitleById,
    findStatusTitleByIdForInternalUser
} from "../../enums/CaseStatus";
import "./CaseTable.css"
import {Autocomplete} from "@mui/lab";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import CaseFilesDialog from "./СaseFilesDialog";
import {debounce} from 'lodash';
import ExcelPopup from "./ExcelPopup";
import {IoIosCloseCircle} from "react-icons/io";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import CaseStatusForDropdown, {findStatusTitleByIdForChip} from "../../enums/CaseStatusForDropdown";
import CaseStatusesForObjectRegistery from "../../enums/CaseStatusesForObjectRegistery";
import {HiDocumentSearch} from "react-icons/hi";
import RewriteRequest from "../../components/CaseInsideTable/RewriteRequest";
import CaseStatusForUserDropDown from "../../enums/caseStatusForUserDropDown";
import CustomAlert from "../../components/ConfirmationModal/CustomAlert";


const geoTitles = [
    {value: "full_address", label: "სრული მისამართი"},
    {value: "region", label: "რეგიონი"},
    {value: "municipality", label: "მუნიციპალიტეტი"},
    {value: "council", label: "საკრებულო"},
    {value: "populated_area", label: "დასახელბული პუნქცი"},
];

const ObjectRegisteryTable = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const urlParams = new URLSearchParams(window.location.search);
    const pageFromUrl = urlParams.get('page');
    const location = useLocation();
    const isObjectRegistery = location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry"
    const [showAlertForRewrite, setShowAlertForRewrite] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [data, setData] = useState([]);
    const [page, setPage] = useState(parseInt(pageFromUrl, 10) ? parseInt(pageFromUrl, 10) : 0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);
    const [caseDeleteTracker, setCaseDeleteTracker] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [searchByRowEvent, setSearchByRowEvent] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isCasePublicModalOn, setIsCasePublicModalOn] = useState(false);
    const [caseIdToDelete, setCaseIdToDelete] = useState(false);
    const [selectedCaseIdForChangingPublicity, setSelectedCaseIdForChangingPublicity] = useState(null);
    const [isTableExpanded, setIsTableExpanded] = useState(isObjectRegistery);
    const [caseNumberFilter, setCaseNumberFilter] = useState('');
    const [oldCaseNumberFilter, setOldCaseNumberFilter] = useState('');
    const isAgencyAnswers = location.pathname === "/agencyanswers"
    const [objectRegistryIdFilter, setObjectRegistryIdFilter] = useState('');
    const [requestFilter, setRequestFilter] = useState('');
    const [noteFilter, setNoteFilter] = useState('');
    const [cadastralFilterForAnswers, setCadastralFilterForAnswers] = useState('');
    const [globalFieldFilter, setGlobalFieldFilter] = useState('');
    const [caseFileInspectFileFileFilters, setCaseFileInspectFileFileFilters] = useState('');
    const [inconsistenciesCritical, setInconsistenciesCritical] = useState('');
    const [inspectCertificate, setInspectCertificate] = useState('');
    const [violationFailureToConductInspection, setViolationFailureToConductInspection] = useState(null);
    const [violationHiddenExploitation, setViolationHiddenExploitation] = useState('');
    const [inconsistenciesNonSubstantial, setInconsistenciesNonSubstantial] = useState('');
    const [inconsistenciesSubstantial, setInconsistenciesSubstantial] = useState('');
    const [userfullInfoFilter, setUserfullInfoFilter] = useState('');
    const [requesterIdFilter, setRequesterIdFilter] = useState('');
    const [objectNameFilter, setObjectNameFilter] = useState('');
    const [cadastralCodeFilter, setCadastralCodeFilter] = useState('');
    const [regionFilter, setRegionFilter] = useState([]);
    const [inspectors, setInspectors] = useState([]);
    const [cityFilter, setCityFilter] = useState([]);
    const [councilFilter, setCouncilFilter] = useState([]);
    const [populatedAreaFilter, setPopulatedAreaFilter] = useState([]);
    const [addressFilter, setAddressFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState([]);
    const [userFilter, setUserFilter] = useState('');
    const [inspectFileCreatorID, setInspectFileCreatorID] = useState('');
    const [inspectFileCertificateCreatorID, setInspectFileCertificateCreatorID] = useState('');
    const [inspectionSertificatIssuingAgency, setInspectionSertificatIssuingAgency] = useState('');
    const [roleFilter, setRoleFilter] = useState('');
    const [createDateFilter, setCreateDateFilter] = useState(null);
    const [inspectionDocumentCreateAt, setInspectionDocumentCreateAt] = useState(null);
    const [inspectionDocumentCreateAtEnd, setInspectionDocumentCreateAtEnd] = useState(null);
    const [inspectionSertificatValidityPeriodDate, setInspectionSertificatValidityPeriodDate] = useState(null);
    const [inspectionSertificatValidityPeriodDateEnd, setInspectionSertificatValidityPeriodDateEnd] = useState(null);
    const [inpectOrderAttachmentDate, setInpectOrderAttachmentDate] = useState(null);
    const [inpectOrderAttachmentDateEnd, setInpectOrderAttachmentDateEnd] = useState(null);
    const [inspectionDocumentCheckDate, setInspectionDocumentCheckDate] = useState(null);
    const [inspectionDocumentCheckDateEnd, setInspectionDocumentCheckDateEnd] = useState(null);
    const [inspectCertificateCreateDate, setInspectCertificateCreateDate] = useState(null);
    const [inspectCertificateCreateDateEnd, setInspectCertificateCreateDateEnd] = useState(null);
    const [inspectionCertificateSertificatValidityPeriodDate, setInspectionCertificateSertificatValidityPeriodDate] = useState(null);
    const [inspectionCertificateSertificatValidityPeriodDatEnd, setInspectionCertificateSertificatValidityPeriodDateEnd] = useState(null);
    const [sertificatReleaseDate, setSertificatReleaseDate] = useState(null);
    const [inconsistenciesCriticalFilter, setInconsistenciesCriticalFilter] = useState(false);
    const [inconsistenciesNonSubstantialFilter, setInconsistenciesNonSubstantialFilter] = useState(false);
    const [inconsistenciesSubstantialFilter, setInconsistenciesSubstantialFilter] = useState(false);
    const [sertificatReleaseDateEnd, setSertificatReleaseDateEnd] = useState(null);
    const [inspectionDocumentmplementation, setInspectionDocumentmplementation] = useState(null);
    const [inspectionDocumentmplementationEnd, setInspectionDocumentmplementationEnd] = useState(null);
    const [createDateFilterEnd, setCreateDateFilterEnd] = useState(null);
    const [deadlineFilter, setDeadlineFilter] = useState(null);
    const [deadlineFilterEnd, setDeadlineFilterEnd] = useState(null);
    const [cities, setCities] = useState([]);
    const [councils, setCouncils] = useState([]);
    const [populatedAreas, setPopulatedAres] = useState([]);
    const [regions, setRegions] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedPermitTypeId, setSelectedPermitTypeId] = useState(null);
    const [permitIdChanged, setPermitIdChanged] = useState(false);
    const [showMainFilesOnDocumentPopup, setShowMainFilesOnDocumentPopup] = useState(false);
    const [showOnlyMainFiles, setShowOnlyMainFiles] = useState(false);
    const [isExcelButtonDisabled, setIsExcelButtonDisabled] = useState(false);
    const [inputTypes, setInputTypes] = useState([]);
    const [mainInputTypes, setMainInputTypes] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    const [uniqueCaseDetailsKeys, setUniqueCaseDetailsKeys] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [userId, setUserId] = useState(null);
    const [permitTypeIdList, setPermitTypeIdList] = useState([]);
    const [mainPermitTypeIdList, setMainPermitTypeIdList] = useState([]);
    const [parentList, setParentList] = useState([]);
    const [mainParentList, setMainParentList] = useState([]);
    const [users, setUsers] = useState([]);
    const [usersMain, setUsersMain] = useState([]);
    const [resetFilters, setResetFilters] = useState(false);
    const [initialSetupComplete, setInitialSetupComplete] = useState(false);
    const navigate = useNavigate();
    const [lastChildren, setLastChildren] = useState([]);
    const [currentDate, setCurrentDate] = useState(null);
    const [sortField, setSortField] = useState(location.pathname === "/dashboard/casenotifications" ? null : "CreateDate");
    const [sortOrder, setSortOrder] = useState(true);
    const [initialSort, setInitialSort] = useState(true);
    const [parentId, setParentId] = useState(null)
    const [createByExpertValue, setCreateByExpertValue] = useState(null);
    const [requestedSpeedUpFilter, setRequestedSpeedUpFilter] = useState(null)
    const [tableViewOptions, setTableViewOptions] = useState(userRole && userRole === "EXPERT" ? 2 : 1)
    const [dialogOpen, setDialogOpen] = useState(false);
    const [loadingNames, setLoadingNames] = useState(false);
    const [isInspectDialogOpen, setIsInspectDialogOpen] = useState(false);
    const [isCasePublic, setIsCasePublic] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
    const [checkedState, setCheckedState] = useState({});
    const [userIds, setUserIds] = useState([]);
    const [permitTree, setPermitTree] = useState([])
    const [buildingDepartments, setBuildingDepartments] = useState([])
    const [explotionDepartments, setExplotionDepartments] = useState([])
    const [objectRegisteryDepartments, setObjectRegisteryDepartments] = useState([])
    const [selectedCases, setSelectedCases] = useState([]);
    const [selectedCasesFullData, setSelectedCasesFullData] = useState([]);
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const [alertInfo, setAlertInfo] = useState({
        open: false,
        message: '',
        severity: 'success',
    });
    const [selectedGeoData, setSelectedGeoData] = useState([
        "full_address",
        "region",
        "municipality",
        "council",
        "populated_area"
    ]);
    const [explotionList, setExplotionList] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`
                );
                const {data} = response.data;

                const collectIdsWithOrderDepartment = (nodes, targetDepartment) => {
                    const result = [];
                    const traverse = (node) => {
                        if (node.orderDepartment === targetDepartment) {
                            result.push(node.id);
                        }
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            node.childrenPermitTypes.forEach(traverse);
                        }
                    };
                    nodes.forEach(traverse);
                    return result;
                };

                const ids = collectIdsWithOrderDepartment(data, 2);
                setExplotionList(ids);
            } catch (error) {
                console.error(error);
            }
        };

        void fetchData();
    }, []);


    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState("");
    const buttonRef = useRef(null);

    const tableTypes = {
        1: "ძირითადი ცხრილი",
        2: "სპეციალისტის ცხრილი",
        3: "გარე მომხმარებლების ცხრილი",
        4: "განაცხადის ცხრილი",
    }

    const objectTypes = {
        1: "ყველა ობიექტი",
        2: "რეგისტრირებული ობიექტები",
        3: "არარეგისტრირებული ობიექტები",
        4: "აქტიური ობიექტები",
        5: "არააქტიური ობიექტები",
    }


    const tabRefs = {};
    const [objectsOfRegistery, setObjectsOfRegistery] = useState([]);

    useEffect(() => {
        console.log(inputTypes)
    }, [inputTypes]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/GetPermitTypeTree`);
                const data = response.data.data;
                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setObjectsOfRegistery(lastNodeChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);

    const handleClick = (item) => {
        const caseId = item.id.toString();
        const targetName = `case-${caseId}`;

        let url = "";

        if (
            location.pathname === "/objectregistry" ||
            location.pathname === "/agencyanswers" ||
            location.pathname === "/dashboard/agencyanswers"
        ) {
            url = `/caseinfo?id=${caseId}`;
        } else if (location.pathname === "/dashboard/admincases") {
            url = `admincaseedit?id=${caseId}`;
        } else if (
            userRole === "ROOTADMIN" &&
            userRole &&
            location.pathname === "/dashboard/hidecases"
        ) {
            return;
        } else {
            url = `/dashboard/mycases/casemanager?id=${caseId}`;
        }

        if (!tabRefs[targetName] || tabRefs[targetName].closed) {
            tabRefs[targetName] = window.open(url, targetName);
        } else {
            tabRefs[targetName].focus();
        }
    };


    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter" && buttonRef.current) {
                e.preventDefault();
                buttonRef.current.click();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [buttonRef]);

    useEffect(() => {
        const caseNumber = sessionStorage.getItem('caseNumber');
        if (location.state?.pageName === 'activecases' && caseNumber) {
            setAlertText(caseNumber)
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                sessionStorage.removeItem("caseNumber")
            }, 6000);
        }
    }, [location.state]);

    useEffect(() => {
        if (isInspectDialogOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isInspectDialogOpen]);


    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            document.querySelectorAll('.header').forEach(el => el.style.display = 'none');
            document.querySelectorAll('.footer-container').forEach(el => el.style.display = 'none');
            document.querySelectorAll('.sidebar-dashboard').forEach(el => el.style.display = 'none');
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
            document.querySelectorAll('.header').forEach(el => el.style.display = '');
            document.querySelectorAll('.footer-container').forEach(el => el.style.display = '');
            document.querySelectorAll('.sidebar-dashboard').forEach(el => el.style.display = '');
        }
    };

    const checkIfObjectIsInRegistery = (objects, object) => {
        return objects.filter(item => item.title === object).length !== 0
    };

    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape" && isInspectDialogOpen) {
                closeInspectDialog();
            }
        }

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [isInspectDialogOpen]);


    useEffect(() => {
        if (tableViewOptions === 4) {
            setIsTableExpanded(false)
        } else if (isObjectRegistery) {
            setIsTableExpanded(true)
        }
    }, [tableViewOptions]);

    useEffect(() => {
        if (userRole === null || userRole === "USER") {
            setCreateByExpertValue(2)
        } else {
            setCreateByExpertValue(1)
        }
    }, [userRole]);

    const getCheckedFields = () => {
        return Object.keys(checkedState).filter(key => checkedState[key] === true);
    }
    const getCheckedFieldsForSearch = () => {
        return Object.keys(checkedState).filter(key => checkedState[key] === true || checkedState[key] === false);
    }
    useEffect(() => {
        setIsExcelButtonDisabled(getCheckedFields().length === 0)
    }, [checkedState]);

    const handleCloseSnackbar = () => {
        setAlertInfo({...alertInfo, open: false});
    };

    const openInspectDialog = () => {
        setIsInspectDialogOpen(true);
    };

    const closeInspectDialog = () => {
        setIsInspectDialogOpen(false);
    };

    const findInspectorById = (userId) => {
        const user = users.find(user => user.id === userId)
        if (user) {
            return `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`
        } else {
            return userId
        }
    }

    useEffect(() => {
        const dynamicInitialState = uniqueCaseDetailsKeys.reduce((acc, key) => {
            acc[key] = true;
            return acc;
        }, {});

        const staticInitialStates = {
            "განაცხადის ნომერი": true,
            "აიტვირთა": true,
            "სრულდება": true,
            "განმცხადებელი": true,
            "სტატუსი": true,
            "რეგიონი": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "ხარვეზის გამოსწორების თარიღი": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "სრული მისამართი": true,
            "მუნიციპალიტეტი": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "საკრებულო": (location.pathname !== '/agencyanswers' && location.pathname !== '/objectregistry' && location.pathname !== '/dashboard/registery' && location.pathname !== '/dashboard/casenotifications'),
            "დასახლებული პუნქტი": (location.pathname !== '/agencyanswers' && location.pathname !== '/objectregistry' && location.pathname !== '/dashboard/registery' && location.pathname !== '/dashboard/casenotifications'),
            "შემსრულებელი": location.pathname !== '/agencyanswers',
            "შემსრულებლის პოზიცია": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "გადამოწმების თარიღი": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "განხორციელების თარიღი": location.pathname === '/dashboard/expiring',
            "მოქმედების ვადა": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "ნებართვის ვადა": location.pathname === '/dashboard/expiring',
            "პირობის ვადა": (location.pathname === '/dashboard/expiring'),
            "შენიშვნა": (location.pathname !== '/agencyanswers' && location.pathname !== '/dashboard/casenotifications'),
            "მოთხოვნა": true,
            "ობიექტი": true,
            "საკადასტრო კოდი": isAgencyAnswers,
            "უწყებრივ რეესტრში რეგისტრაციის ნომერი": location.pathname.startsWith("/dashboard/registery") || location.pathname.startsWith("/objectregistry"),
        };


        if (location.pathname === '/agencyanswers') {
            setCheckedState({...staticInitialStates});
        } else {
            setCheckedState({...staticInitialStates, ...dynamicInitialState});
        }

    }, [uniqueCaseDetailsKeys]);


    useEffect(() => {
        if (location.pathname === "/dashboard/declinedcases") {
            setStatusFilter([4])
        } else if (location.pathname === "/dashboard/finishedcases") {
            setStatusFilter([3, 10, 8])
        }
    }, [location]);


    const handleCheckboxChange = (fieldName, checked) => {
        setCheckedState(prevState => ({
            ...prevState,
            [fieldName]: checked
        }));
    };

    const handleSelectCase = (caseData, caseId, requesterId) => {
        setSelectedCases(prevState => {
            const exists = prevState.some(item => item.caseId === caseId);
            if (exists) {
                return prevState.filter(item => item.caseId !== caseId);
            } else {
                return [...prevState, {caseId, allOldRequesterIds: [requesterId]}];
            }
        });

        setSelectedCasesFullData(prevData => {
            const exists = prevData.some(item => item.id === caseId);
            return exists
                ? prevData.filter(item => item.id !== caseId)
                : [...prevData, caseData];
        });
    };


    const unselectCases = () => {
        setShowAlertForRewrite(true);
        setAlertMessage("ოპერაცია წარმატებნით დასრულდა");
        setAlertType("success");
        setSelectedCases([]);
        setSelectedCasesFullData([]);

    };

    function formatGeoData(item) {
        let fullData = [];

        if (item.regionsNames) {
            fullData.push(item.regionsNames);
        }
        if (item.citysNames) {
            fullData.push(item.citysNames);
        }
        if (item.councilsNames) {
            fullData.push(item.councilsNames);
        }
        if (item.populatedAreasNames) {
            fullData.push(item.populatedAreasNames);
        }

        const concatenatedData = fullData.join(", ");
        return {
            fullText: concatenatedData,
            displayText: concatenatedData.length > 80 ? concatenatedData.substring(0, 80) + '...' : concatenatedData
        };
    }


    const handleChangeGeoData = (event) => {
        setSelectedGeoData(event.target.value);
    };

    const deleteCase = async () => {
        try {
            const caseData = {
                id: caseIdToDelete
            };

            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/ DeleteCaseByAdminAndInternal`, caseData);

        } catch (error) {
        } finally {
            setIsDeleteModalOpen(false)
            setCaseDeleteTracker(caseDeleteTracker)
            await fetchDataTable(page)
        }
    };
    const changeCaseVisibility = async () => {
        try {
            const caseData = {
                caseID: selectedCaseIdForChangingPublicity,
                isPublic: !isCasePublic
            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseIsPublicByCaseID`, caseData);

        } catch (error) {
        } finally {
            setIsCasePublicModalOn(false)
            setCaseDeleteTracker(caseDeleteTracker)
            await fetchDataTable(page)
        }
    };

    const collectIds = (department) => {
        let ids = [];

        function traverse(departmentNode) {
            if (!departmentNode) return;

            ids.push(departmentNode.id);

            if (departmentNode.childrenPermitTypes && departmentNode.childrenPermitTypes.length > 0) {
                departmentNode.childrenPermitTypes.forEach(child => {
                    traverse(child);
                });
            }
        }

        traverse(department);
        return ids;
    }

    const isGeoDataInGeoArray = (geoData) => {
        return selectedGeoData.includes(geoData);
    };

    useEffect(() => {
        if (permitTree.length !== 0) {
            setBuildingDepartments(collectIds(permitTree[0]))
            setExplotionDepartments(collectIds(permitTree[1]))
            setObjectRegisteryDepartments(collectIds(permitTree[2]))
        }
    }, [permitTree]);


    useEffect(() => {
        if (userRole && userRole === "EXPERT") {
            setTableViewOptions(2)
        }
    }, [userRole]);

    const fetchNonInternalUsers = useCallback(debounce(async (name) => {
        setLoadingNames(true)
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetAllNonInternalUsers?FilterByUserFullName=${name}`);
            const fetchedUserIds = response.data.data.result.slice(0, 50)

            setUserIds(fetchedUserIds);
            setLoadingNames(false)
        } catch (error) {
            setUserIds([]);
            setLoadingNames(false)
        }
    }, 200), []);

    useEffect(() => {
        if (requesterIdFilter.trim()) {
            fetchNonInternalUsers(requesterIdFilter);
        } else {
            setUserIds([]);
        }
    }, [requesterIdFilter, fetchNonInternalUsers])

    const handleOpenDialog = (id, showMainFiles, showOnlyMainFiles) => {
        setSelectedId(id);
        setShowOnlyMainFiles(showOnlyMainFiles)
        setShowMainFilesOnDocumentPopup(showMainFiles)
        setDialogOpen(true);
    };


    const handleCloseDialog = () => {
        setDialogOpen(false);
    };


    const handleChange = (event) => {
        setCreateByExpertValue(event.target.value);
    };
    const handleChangeTableOptions = (event) => {
        setTableViewOptions(event.target.value);
    };
    const handleChangeDepartment = (event) => {
        setSelectedDepartmentId(event.target.value);
    };

    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };
    const [geoIds, setGeoIds] = useState({
        regionId: null,
        municipalityId: null,
        councilId: null,
        cityId: null
    });


    const getUserById = (userId) => {
        const user = users.find(user => user.id === userId);
        if (user) {
            return `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`
        } else {
            return ''
        }

    };

    const findObjectTitleById = (objectId) => {
        const object = permitTypeIdList.find(child => child.id === objectId)
        return object ? object.description : ""
    };


    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetAllInternalUsers`);

            const sortedUsers = response.data.data.result.sort((a, b) => {
                return a.firstName.localeCompare(b.firstName);
            });

            setUsers(sortedUsers);
            setUsersMain(sortedUsers);
        } catch (error) {
        }
    };
    useEffect(() => {
        if (userRole !== null && userRole !== "USER" && users.length === 0) {
            void fetchUsers()
        }
    }, [userRole]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryTypes`);
                if (response.data.success) {
                    extractIds(response.data.data);
                }
            } catch (error) {
            }
        };

        const extractIds = (data) => {
            const idMap = {
                'რეგიონი': 'regionId',
                'მუნიციპალიტეტი': 'municipalityId',
                'საკრებულო': 'councilId',
                'ქალაქი': 'cityId'
            };
            let newIds = {...geoIds};
            data.forEach(item => {
                const key = idMap[item.typesName];
                if (key) {
                    newIds[key] = item.id;
                }
            });
            setGeoIds(newIds);
        };
        void fetchData();
    }, []);

    useEffect(() => {
        sessionStorage.setItem('caseNumberList', '');
    }, []);

    useEffect(() => {
        if (location.pathname !== "/dashboard/casenotifications") {
            handleSortChange('CreateDate')
        } else {
            handleSortChange(null)
        }

    }, []);

    const handleSortChange = (fieldName) => {
        if (initialSort) {
            setSortOrder(false)
            setSortField(fieldName);
            setInitialSort(false)
        }
        {
            setSortOrder((currentSortOrder) => {
                return sortField === fieldName ? !currentSortOrder : false;
            });
            setSortField(fieldName);
        }
    };


    useEffect(() => {
        if (explotionList.length === 0) return

        if (initialSetupComplete && lastChildren.length !== 0) {
            void fetchDataTable(page);
        }
    }, [explotionList, sortField, selectedPermitTypeId, caseDeleteTracker, sortOrder, initialSetupComplete, location.pathname, page, createByExpertValue, lastChildren, selectedDepartmentId, pageSize]);


    const renderFilterChips = () => {
        let filterChips = [];

        if (globalFieldFilter) filterChips.push({key: 'ზოგადი ველი', label: globalFieldFilter});
        if (caseNumberFilter) filterChips.push({key: 'განაცხადის ნომერი', label: caseNumberFilter});

        if (createByExpertValue && createByExpertValue !== 1) filterChips.push({
            key: 'ობიექტის სტატუსი',
            label: objectTypes[createByExpertValue]
        });
        if (requestFilter) filterChips.push({key: 'მოთხოვნა', label: requestFilter});
        if (noteFilter) filterChips.push({key: 'შენიშვნა', label: noteFilter});
        if (cadastralFilterForAnswers) filterChips.push({key: 'საკადასტრო კოდი', label: cadastralFilterForAnswers});
        if (selectedPermitTypeId) filterChips.push({key: 'ობიექტი', label: selectedPermitTypeId});
        if (userFilter) filterChips.push({key: 'შემსრულებელი', label: userFilter});
        if (caseFileInspectFileFileFilters) filterChips.push({
            key: 'ინსპექტირების ოქმის სახელი',
            label: caseFileInspectFileFileFilters
        });
        if (inconsistenciesCritical) filterChips.push({
            key: 'კრიტიკული შეუსაბამომებები',
            label: inconsistenciesCritical
        });
        if (inconsistenciesNonSubstantial) filterChips.push({
            key: 'არსებითი შეუსაბამომებები',
            label: inconsistenciesNonSubstantial
        });
        if (inconsistenciesSubstantial) filterChips.push({
            key: 'არაარსებითი შეუსაბამომებები',
            label: inconsistenciesSubstantial
        });
        if (roleFilter) filterChips.push({key: 'პოზიცია', label: rolesInGeorgian[roleFilter]});
        if (requestedSpeedUpFilter !== null) filterChips.push({
            key: 'დაჩქარებული წესით გაცემული განაცხადები',
            label: requestedSpeedUpFilter ? "კი" : "არა"
        });
        if (requesterIdFilter) filterChips.push({key: 'განმცხადებელი', label: requesterIdFilter});
        if (createDateFilter) filterChips.push({
            key: 'ატვირთვის თარიღიდან',
            label: formatDate(createDateFilter),
            id: 'createDateFrom'
        });
        if (inspectionDocumentCreateAtEnd) filterChips.push({
            key: 'ინსპექტირების ოქმის ატვირთვის თარიღამდე',
            label: formatDate(inspectionDocumentCreateAtEnd),
            id: 'inspectionDocumentCreateAtEnd'
        });
        if (inspectionDocumentCreateAt) filterChips.push({
            key: 'ინსპექტირების ოქმის ატვირთვის თარიღიდან',
            label: formatDate(inspectionDocumentCreateAt),
            id: 'inspectionDocumentCreateAt'
        });
        if (inspectionDocumentCheckDate) filterChips.push({
            key: 'გადამოწმების თარიღიდან',
            label: formatDate(inspectionDocumentCheckDate),
            id: 'inspectionDocumentCheckDate'
        });
        if (inspectionDocumentCheckDateEnd) filterChips.push({
            key: 'გადამოწმების თარიღამდე',
            label: formatDate(inspectionDocumentCheckDateEnd),
            id: 'inspectionDocumentCheckDateEnd'
        });


        if (inspectionDocumentmplementationEnd) filterChips.push({
            key: 'გადამოწმების თარიღამდე',
            label: formatDate(inspectionDocumentmplementationEnd),
            id: 'inspectionDocumentmplementationEnd'
        });
        if (createDateFilterEnd) filterChips.push({
            key: 'ატვირთვის თარიღამდე',
            label: formatDate(createDateFilterEnd),
            id: 'createDateTo'
        });
        if (deadlineFilter) filterChips.push({
            key: 'დასრულების თარიღიდან',
            label: formatDate(deadlineFilter),
            id: 'deadlineFrom'
        });

        if (violationFailureToConductInspection === 1 || violationFailureToConductInspection === 0) filterChips.push({
            key: 'ინსპექტირების ჩაუტარებლობა დარღვევა',
            label: violationFailureToConductInspection === 1 ? "კი" : "არა"
        });
        if (inspectCertificate) filterChips.push({
            key: 'ინსპექტირების სერთიფიკატის სახელი',
            label: inspectCertificate
        });
        if (inspectFileCertificateCreatorID) filterChips.push({
            key: 'ინსპექტირების სერთიფიკატი ატვირთა',
            label: inspectFileCertificateCreatorID
        });

        if (inspectFileCreatorID) filterChips.push({
            key: 'ინსპექტირების ოქმი ატვირთა',
            label: inspectFileCreatorID
        });
        if (inspectionSertificatIssuingAgency) filterChips.push({
            key: 'გამცემი ორგანო',
            label: inspectionSertificatIssuingAgency
        });
        if (inspectors.length !== 0) {
            filterChips.push({
                key: 'ინსპექტორები',
                label: inspectors.map(findInspectorById).join(', ')
            });
        }


        if (violationHiddenExploitation === 1 || violationHiddenExploitation === 0) filterChips.push({
            key: 'ფარული ექსპლუატაცია დარღვევა',
            label: violationHiddenExploitation === 1 ? "კი" : "არა"
        });
        if (tableViewOptions && userRole && userRole !== "EXPERT" && tableViewOptions !== 1) filterChips.push({
            key: 'ცხრილის ტიპი',
            label: tableViewOptions === 2 ? "სპეციალისტის ცხრილი" :
                tableViewOptions === 3 ? "გარე მომხმარებლების ცხრილი" :
                    tableViewOptions === 4 ? "განაცხადის ცხრილი" :
                        "ძირითადი ცხრი  ლი"
        });
        if (selectedDepartmentId) filterChips.push({
            key: 'სამმართველო',
            label: selectedDepartmentId === 1 ? "მშენებლობის ნებართვა" :
                selectedDepartmentId === 2 ? "სამრეწველო დანიშნულების ფეთქებადი მასალები" :
                    "მომეტებული საფრთხის შემცვლელი ობიექტები"
        });

        if (deadlineFilterEnd) filterChips.push({
            key: 'დასრულების თარიღამდე',
            label: formatDate(deadlineFilterEnd),
            id: 'deadlineTo'
        });

        if (inpectOrderAttachmentDate) filterChips.push({
            key: 'შედგენის თარიღიდან',
            label: formatDate(inpectOrderAttachmentDate),
            id: 'inpectOrderAttachmentDate'
        });
        if (inpectOrderAttachmentDateEnd) filterChips.push({
            key: 'შედგენის თარიღამდე',
            label: formatDate(inpectOrderAttachmentDateEnd),
            id: 'inpectOrderAttachmentDateEnd'
        });

        if (inspectionCertificateSertificatValidityPeriodDate) filterChips.push({
            key: 'მოქმედების ვადიდან',
            label: formatDate(inspectionCertificateSertificatValidityPeriodDate),
            id: 'inspectionCertificateSertificatValidityPeriodDate'
        });

        if (inspectionCertificateSertificatValidityPeriodDatEnd) filterChips.push({
            key: 'მოქმედების ვადამდე',
            label: formatDate(inspectionCertificateSertificatValidityPeriodDatEnd),
            id: 'inspectionCertificateSertificatValidityPeriodDateEnd'
        });


        if (inspectCertificateCreateDate) filterChips.push({
            key: 'ინსპექტირების სერტიფიკატის ატვირთვის თარიღიდან',
            label: formatDate(inspectCertificateCreateDate),
            id: 'inspectCertificateCreateDate'
        });
        if (inspectCertificateCreateDateEnd) filterChips.push({
            key: 'ინსპექტირების სერტიფიკატის ატვირთვის თარიღამდე',
            label: formatDate(inspectCertificateCreateDateEnd),
            id: 'inspectCertificateCreateDateEnd'
        });
        if (sertificatReleaseDate) filterChips.push({
            key: 'გაცემის თარიღიდან',
            label: formatDate(sertificatReleaseDate),
            id: 'sertificatReleaseDate'
        });
        if (sertificatReleaseDateEnd) filterChips.push({
            key: 'გაცემის თარიღამდე',
            label: formatDate(sertificatReleaseDateEnd),
            id: 'sertificatReleaseDateEnd'
        });
        if (inconsistenciesCriticalFilter) filterChips.push({
            key: 'კრიტიკული შეუსაბამომებები',
            label: "კი",
            id: 'inconsistenciesCriticalFilter'
        });
        if (inconsistenciesNonSubstantialFilter) filterChips.push({
            key: 'არსებითი შეუსაბამომებები',
            label: "კი",
            id: 'inconsistenciesNonSubstantialFilter'
        });
        if (inconsistenciesSubstantialFilter) filterChips.push({
            key: 'არაარსებითი შეუსაბამომებები',
            label: "კი",
            id: 'inconsistenciesSubstantialFilter'
        });
        if (inspectionSertificatValidityPeriodDate) filterChips.push({
            key: 'განცხორციელების თარიღიდან',
            label: formatDate(inspectionSertificatValidityPeriodDate),
            id: 'inspectionSertificatValidityPeriodDate'
        });
        if (inspectionSertificatValidityPeriodDateEnd) filterChips.push({
            key: 'განცხორციელების თარიღამდე',
            label: formatDate(inspectionSertificatValidityPeriodDateEnd),
            id: 'inspectionSertificatValidityPeriodDateEnd'
        });

        if (statusFilter.length > 0) {
            const labels = statusFilter.map(statusId => findStatusTitleByIdForChip(statusId)).join(', ');
            filterChips.push({
                key: 'სტატუსი',
                label: labels,
                id: `status-${statusFilter.join('-')}`
            });
        }


        regionFilter.forEach(id => {
            const region = regions.find(r => r.id === id);
            if (region) {
                filterChips.push({key: 'რეგიონი', label: region.itemName, id});
            }
        });

        cityFilter.forEach(id => {
            const city = cities.find(c => c.id === id);
            if (city) {
                filterChips.push({key: 'მუნიციპალიტეტი', label: city.typesName, id});
            }
        });

        councilFilter.forEach(id => {
            const council = councils.find(c => c.id === id);
            if (council) {
                filterChips.push({key: 'საკონსულო', label: council.typesName, id});
            }
        });

        populatedAreaFilter.forEach(id => {
            const area = populatedAreas.find(a => a.id === id);
            if (area) {
                filterChips.push({key: 'დასახლებული პუნქტი', label: area.typesName, id});
            }
        });

        inputTypes.forEach(inputType => {
            const value = filterValues[inputType.title];
            if (value) {
                filterChips.push({key: inputType.title, label: value});
            }
        });


        if (filterChips.length !== 0 && permitTypeIdList.length !== 0) {
            return (
                <div className="chip-container">
                    {filterChips.map(chip => (
                        chip.key === "შემსრულებელი" ||
                        chip.key === "ინსპექტირების ოქმი ატვირთა" ||
                        chip.key === "ინსპექტირების სერთიფიკატი ატვირთა"
                            ? (
                                <Chip
                                    key={chip.id ? `${chip.key}-${chip.id}` : chip.key}
                                    label={`${chip.key}: ${getUserById(chip.label)}`}
                                    onDelete={() => handleDelete(chip)}
                                    color="primary"
                                    variant="outlined"
                                    className="filter-chip"
                                    style={{margin: '5px'}}
                                />
                            ) : chip.key === "ობიექტი" ? (
                                <Chip
                                    key={chip.id ? `${chip.key}-${chip.id}` : chip.key}
                                    label={`${chip.key}: ${findObjectTitleById(chip.label)}`}
                                    onDelete={() => handleDelete(chip)}
                                    color="primary"
                                    variant="outlined"
                                    className="filter-chip"
                                    style={{margin: '5px'}}
                                />
                            ) : (
                                <Chip
                                    key={chip.id ? `${chip.key}-${chip.id}` : chip.key}
                                    label={`${chip.key}: ${chip.label}`}
                                    onDelete={() => handleDelete(chip)}
                                    color="primary"
                                    variant="outlined"
                                    className="filter-chip"
                                    style={{margin: '5px'}}
                                />
                            )

                    ))}
                </div>
            );
        }
    };


    useEffect(() => {
        const fetchCurrentDate = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Datetime/GetDatetimeNow`);
                setCurrentDate(new Date(response.data));

            } catch (error) {
            }
        };
        void fetchCurrentDate();
    }, []);
    const checkIfBlinkingNeeded = (deadlineDateStr, caseStatus) => {
        if (!currentDate) return false;

        if (userRole === "USER" ||
            location.pathname === "/agencyanswers" ||
            location.pathname === "/objectregistry" ||
            location.pathname === "dashboard/agencyanswers" ||
            [
                CaseStatus.Unexamined.id,
                CaseStatus.expertCase.id,
                CaseStatus.ConditionalEnded.id,
                CaseStatus.Invalid.id,
                CaseStatus.FinishedDenied.id,
                CaseStatus.Canceled.id,
                CaseStatus.Approved.id,
            ].includes(caseStatus)

        ) {
            return false;
        }

        const deadlineDate = new Date(deadlineDateStr);
        const timeDiff = deadlineDate.getTime() - currentDate.getTime();
        const dayDiff = timeDiff / (1000 * 3600 * 24);
        return dayDiff <= 5;
    };


    useEffect(() => {
        if ((location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && selectedPermitTypeId !== null) {
            localStorage.setItem('parentId', JSON.stringify(parentId))
        }
    }, [selectedPermitTypeId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;
                setPermitTree(data)

                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setLastChildren(lastNodeChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    const handlePermitTypeChange = (permitTypeID) => {
        const selectedPermit = permitTypeIdList.find(item => item.id === permitTypeID);
        const parentId = selectedPermit ? selectedPermit.parentId : null;
        clearFilters();
        setSelectedPermitTypeId(permitTypeID);
        if (location.pathname !== "/dashboard/registery" || location.pathname !== "/objectregistry") {
            setParentId(parentId);
        }
        localStorage.setItem(location.pathname + 'selectedPermitTypeId', JSON.stringify(permitTypeID));
        localStorage.setItem(location.pathname + 'parentId', JSON.stringify(parentId));
    };

    const handlePermitTypeChangeRegistery = (event) => {
        const newValue = event.target.value === '' ? null : Number(event.target.value);
        setSelectedPermitTypeId(newValue);
        localStorage.setItem(location.pathname + 'selectedPermitTypeId', JSON.stringify(newValue));
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;
                const findLastChildren = (nodes, rootParentId = null) => {
                    let lastChildren = [];
                    nodes.forEach(node => {
                        const currentRootParentId = rootParentId === null ? node.id : rootParentId;
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            lastChildren = [...lastChildren, ...findLastChildren(node.childrenPermitTypes, currentRootParentId)];
                        } else {
                            lastChildren.push({id: node.id, description: node.title, parentId: currentRootParentId});
                        }
                    });
                    return lastChildren;
                };

                const findMainParents = (nodes) => {
                    return nodes.map(node => ({id: node.id, description: node.title, parentId: node.permitTypeId}));
                };
                const lastChildren = findLastChildren(data);
                const mainParents = findMainParents(data);
                setPermitTypeIdList(lastChildren);
                setMainPermitTypeIdList(lastChildren);
                setParentList(mainParents);
                setMainParentList(mainParents);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);

    useEffect(() => {
        if (mainPermitTypeIdList.length !== 0 && mainParentList.length !== 0) {

            if (selectedDepartmentId === null) {
                setPermitTypeIdList(mainPermitTypeIdList)
            } else if (selectedDepartmentId === 1) {
                const filteredBuildingDepartments = mainPermitTypeIdList.filter(department =>
                    buildingDepartments.includes(department.id)
                );
                const filteredBuildingDepartment = mainParentList.filter(department =>
                    buildingDepartments.includes(department.id)
                );
                setParentList(filteredBuildingDepartment)
                setPermitTypeIdList(filteredBuildingDepartments)
            } else if (selectedDepartmentId === 2) {
                const filteredExplotionDepartments = mainPermitTypeIdList.filter(department =>
                    explotionDepartments.includes(department.id)
                );
                const filteredExplotionDepartment = mainParentList.filter(department =>
                    explotionDepartments.includes(department.id)
                );
                setParentList(filteredExplotionDepartment)
                setPermitTypeIdList(filteredExplotionDepartments)
            } else if (selectedDepartmentId === 3) {
                const filteredObjectRergistertyDepartments = mainPermitTypeIdList.filter(department =>
                    objectRegisteryDepartments.includes(department.id)
                );
                const filteredObjectRergistertyDepartment = mainParentList.filter(department =>
                    objectRegisteryDepartments.includes(department.id)
                );
                setParentList(filteredObjectRergistertyDepartment)
                setPermitTypeIdList(filteredObjectRergistertyDepartments)
            }
            setPermitIdChanged(true)


        }


    }, [selectedDepartmentId]);
    useEffect(() => {
        if (permitTypeIdList.length !== 0 && selectedPermitTypeId && permitIdChanged) {
            const containsParentId = permitTypeIdList.some(item => item.id === selectedPermitTypeId);
            if (!containsParentId) {
                localStorage.removeItem(location.pathname + 'selectedPermitTypeId')
                setSelectedPermitTypeId(null)
                setPermitIdChanged(false)
                setResetFilters(true)
            }

        }
    }, [permitTypeIdList, selectedDepartmentId, permitIdChanged]);


    useEffect(() => {
        const decodeJWT = () => {
            const token = localStorage.getItem('jwtToken');
            if (!token) return '';
            try {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                return JSON.parse(jsonPayload);
            } catch (error) {
                return null;
            }
        };
        const payload = decodeJWT();

        if (payload && payload.role) {

            setUserRole(payload.role);
            setUserId(payload.UserId);
        }
    }, []);

    useEffect(() => {
        const userInputFields = inputTypes.filter(inputType => inputType.visibleOnTableForUser).map(input => input.title);
        const workerInputFields = inputTypes.filter(inputType => inputType.visibleOnTable).map(input => input.title);
        const allInputTypes = inputTypes.filter(inputType => inputType.visibleOnTable && inputType.visibleOnTableForUser).map(input => input.title)
        const userKeys = new Set();
        const workerKeys = new Set();
        const allKeys = new Set();

        data.forEach(item => {
            item.caseDetails.forEach(detail => {
                if (userInputFields.includes(detail.key)) {
                    userKeys.add(detail.key);
                }
                if (workerInputFields.includes(detail.key)) {
                    workerKeys.add(detail.key);
                }
                if (allInputTypes.includes(detail.key)) {
                    allKeys.add(detail.key);
                }

            });
        });
        if (!userRole || userRole === "USER") {
            setUniqueCaseDetailsKeys([...userKeys]);
        } else if (userRole !== "USER") {
            switch (tableViewOptions) {
                case 1:
                    setUniqueCaseDetailsKeys([...allKeys]);
                    break;
                case 2:
                    setUniqueCaseDetailsKeys([...workerKeys]);
                    break;
                case 3:
                    setUniqueCaseDetailsKeys([...userKeys]);
                    break;
                default:
                    setUniqueCaseDetailsKeys([...allKeys]);
                    break;
            }
        }


    }, [data, userRole, inputTypes, tableViewOptions]);

    useEffect(() => {
        const userInputTypes = mainInputTypes.filter(input => input.visibleOnTableForUser)
        const workerInputTypes = mainInputTypes.filter(input => input.visibleOnTable)
        const allInputTypes = mainInputTypes.filter(input => input.visibleOnTable && input.visibleOnTableForUser)
        if (userRole && userRole !== "USER") {
            if (tableViewOptions === 1) {
                setInputTypes(allInputTypes)
            } else if (tableViewOptions === 2) {
                setInputTypes(workerInputTypes)
            } else if (tableViewOptions === 3) {
                setInputTypes(userInputTypes)
            }
        }

    }, [mainInputTypes, tableViewOptions]);


    useEffect(() => {
        if (parentId !== null && parentId !== '') {
            const fetchInputTypes = async () => {
                setLoading(true);
                try {
                    const response = await axios.get(`${baseURL}/GetInputTypesByCaseID?CaseId=${parentId}`);
                    if (response.data.success) {
                        if (userRole && userRole !== "USER") {
                            setInputTypes(response.data.data.list);
                            setMainInputTypes(response.data.data.list);
                        } else {
                            setInputTypes(response.data.data.list.filter(input => input.internal === false))
                            setMainInputTypes(response.data.data.list.filter(input => input.internal === false))
                        }

                    }
                } catch (error) {
                } finally {
                }
            };

            void fetchInputTypes();
        } else {
            setInputTypes([]);
        }
    }, [selectedPermitTypeId, parentId]);


    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const response = await axios.get(`${baseURL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                if (response.data && response.data.success) {
                    setRegions(response.data.data.resultlist);
                }
            } catch (error) {
            }
        };

        void fetchRegions();
    }, [geoIds]);

    const handleExportToExcel = async () => {
        setLoadingExport(true);
        const requestBody = buildRequestBody(true);
        let exportURL = '';

        switch (location.pathname) {
            case '/dashboard/casenotifications':
                requestBody.viewed = false;
                exportURL = `${baseURL}/GetAllCaseByActiveUserIdExport`;
                break;
            case '/dashboard/manageractivecases':
                requestBody.viewed = true;
                exportURL = `${baseURL}/GetAllCaseByActiveUserIdExport`;
                break;
            case '/dashboard/currentcases':
                exportURL = `${baseURL}/GetAllCasesInProgressExport?`;
                break;
            case '/dashboard/finishedcases':
                exportURL = `${baseURL}/GetAllCasePublicExport?finished=true`;
                requestBody.statuses = [3, 10, 8]
                break;
            case '/dashboard/permitdoc':
                exportURL = `${baseURL}/GetAllCasePublicExport`;
                requestBody.filterCaseByHasBuilidngDocumentFilterLogic = true
                break;

            case '/dashboard/expfiles':
                exportURL = `${baseURL}/GetAllCasePublicExport`;
                requestBody.filterByExplotionFile = true
                requestBody.permitTypDepartmentId = 1
                break;
            case '/agencyanswers':
                requestBody.CreteByExpert = false;
                exportURL = `${baseURL}/GetAllCasePublicExport?`;
                break;
            case '/dashboard/agencyanswers':
                exportURL = `${baseURL}/GetAllCasePublicExport?`;
                break;
            case '/objectregistry':
                if (userRole === "USER") {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 1) {
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 2) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 3) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = false;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 4) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    requestBody.caseIsActive = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 5) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = false;
                    requestBody.caseIsActive = false;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                }
                break;
            case '/dashboard/delayedcases':
                exportURL = `${baseURL}/GetAllCaseOverdueExport?`;
                break;
            case '/dashboard/historycases':
                exportURL = `${baseURL}/GetAllCaseExport?`;
                break;
            case '/dashboard/activecases':
                exportURL = `${baseURL}/GetAllCasePublicExport?`;
                break;
            case '/dashboard/newcases':
                exportURL = `${baseURL}/GetAllCasePublicExport?`;
                break;
            case '/dashboard/registery':
                if (userRole === "USER") {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 1) {
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 2) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 3) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = false;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 4) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    requestBody.caseIsActive = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else if (createByExpertValue === 5) {
                    requestBody.MoveCaseToAgencyRegisterByExpert = false;
                    requestBody.caseIsActive = false;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                } else {
                    requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    exportURL = `${baseURL}/GetAllCasePublicExport?`;
                }

                break;
            default:
                setLoadingExport(false);
                return;
        }

        if (selectedPermitTypeId !== null) {
            exportURL += `permitTypeId=${selectedPermitTypeId}&`;
        }


        try {
            const response = await axios.post(exportURL, requestBody, {responseType: 'blob'});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'განაცხადები.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setLoadingExport(false);

            setAlertInfo({
                open: true,
                message: 'ოპერაცია წარმატებით დასრულდა!',
                severity: 'success',
            });
        } catch (error) {
            setLoadingExport(false);
            setAlertInfo({
                open: true,
                message: 'დაფიქსირდა შეცდომა!',
                severity: 'error',
            });

        }
    };


    const fetchDataTable = async (pageNumber = page) => {
        setLoading(true);
        try {
            const requestBody = buildRequestBody();
            requestBody.page = pageNumber;

            let endpoint = '';

            switch (location.pathname) {
                case '/dashboard/casenotifications':
                    requestBody.viewed = false;
                    endpoint = `${baseURL}/GetAllCaseByActiveUserId`;
                    break;
                case '/dashboard/secretdocuments':
                    requestBody.filterByIsSecretFile = true;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/docsToSign':
                    requestBody.filterBySignStatus = 2;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/waitingToSign':
                    requestBody.filterBySignStatus = 3;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/objectregistrationtable':
                    requestBody.CreteByExpert = true;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/manageractivecases':
                    requestBody.viewed = true;
                    endpoint = `${baseURL}/GetAllCaseByActiveUserId`;
                    break;
                case '/dashboard/mydeclinedcases':
                    requestBody.filterCasebyDeclinedCaseFileStatusStatus = true;
                    endpoint = `${baseURL}/GetAllCasesInProgress`;
                    break;
                case '/dashboard/declinedcases':
                    endpoint = `${baseURL}/GetAllCase`;
                    break;
                case '/dashboard/currentcases':
                    requestBody.foltedByCaseNotificationStatusSentForVisage = true;
                    endpoint = `${baseURL}/GetAllCasesInProgress`;
                    break;
                case '/dashboard/finishedcases':
                    requestBody.statuses = [3, 10, 8]
                    endpoint = `${baseURL}/GetAllCase?finished=true`;
                    break;
                case '/dashboard/permitdoc':
                    requestBody.filterCaseByHasBuilidngDocumentFilterLogic = true
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/expfiles':
                    requestBody.filterByExplotionFile = true
                    requestBody.pertmiTypeIdList = explotionList
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/lastusercases':
                    requestBody.activeUserId = userId
                    requestBody.creteByExpert = false
                    requestBody.hideStatus = CaseStatus.CaseCreatedWithoutFiles.id
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/myfinishedcases':
                    requestBody.statuses = [3, 10, 8]
                    endpoint = `${baseURL}/GetAllCaseByRequesterId`;
                    break;
                case '/agencyanswers':
                    requestBody.CreteByExpert = false;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/agencyanswers':
                    requestBody.CreteByExpert = false;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/dashboard/admincases':
                    requestBody.CreteByExpert = false;
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;

                case '/dashboard/hidecases':
                    endpoint = `${baseURL}/GetAllCasePublic`;
                    break;
                case '/objectregistry':
                    endpoint = `${baseURL}/GetAllCasePublic`;

                    if (userRole === "USER" || !userRole) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    } else if (createByExpertValue === 1) {
                    } else if (createByExpertValue === 2) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    } else if (createByExpertValue === 3) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = false;
                    } else if (createByExpertValue === 4) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                        requestBody.caseIsActive = true;
                    } else if (createByExpertValue === 5) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = false;
                        requestBody.caseIsActive = false;
                    } else {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                    }
                    break;
                case '/dashboard/delayedcases':
                    endpoint = `${baseURL}/GetAllCaseOverdue`;
                    break;
                case '/dashboard/historycases':
                    endpoint = `${baseURL}/GetAllCase`;
                    break;
                case '/dashboard/expiring':
                    requestBody.isTermOfPermissionAndCondition = true;
                    requestBody.filterByRole = false;
                    endpoint = `${baseURL}/GetAllCase`;
                    break;
                case '/dashboard/activecases':
                    endpoint = `${baseURL}/GetAllCaseByRequesterId`;
                    break;
                case '/dashboard/newcases':
                    endpoint = `${baseURL}/GetAllCaseByRequesterIdNew`;
                    break;
                case '/dashboard/registery':
                    if (userRole === "USER") {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    } else if (createByExpertValue === 1) {
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    } else if (createByExpertValue === 2) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    } else if (createByExpertValue === 3) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = false;
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    } else if (createByExpertValue === 4) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                        requestBody.caseIsActive = true;
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    } else if (createByExpertValue === 5) {
                        requestBody.MoveCaseToAgencyRegisterByExpert = false;
                        requestBody.caseIsActive = false;
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    } else {
                        requestBody.MoveCaseToAgencyRegisterByExpert = true;
                        endpoint = `${baseURL}/GetAllCasePublic`;
                    }
                    break;
                default:
                    setLoading(false);
                    return;
            }
            const fetchPromise = await axios.post(endpoint, requestBody);
            const [response] = await Promise.all([fetchPromise, delay(1500)]);
            const totalCount = response.data.data.totalCount !== undefined ? response.data.data.totalCount : response.data.data.listCount;
            setData(response.data.data?.data || response.data.data?.items || response.data.data?.result || []);
            setTotalPages(Math.ceil(totalCount / pageSize));
            setTotalRecords(totalCount);
            closeInspectDialog()

        } catch (error) {
            setData([])
        } finally {
            setLoading(false);
        }
    };


    const clearFilters = () => {
        setSelectedPermitTypeId(null)
        setCaseNumberFilter('');
        setOldCaseNumberFilter('');
        setObjectRegistryIdFilter('');
        setRequestFilter('');
        setNoteFilter('');
        setCadastralFilterForAnswers('');
        setGlobalFieldFilter('');
        setCaseFileInspectFileFileFilters('');
        setInconsistenciesCritical('');
        setInspectCertificate('');
        setViolationFailureToConductInspection(null);
        setViolationHiddenExploitation('');
        setInconsistenciesNonSubstantial('');
        setInconsistenciesSubstantial('');
        setUserfullInfoFilter('');
        setRequesterIdFilter('');
        setObjectNameFilter('');
        setCadastralCodeFilter('');
        setRegionFilter([]);
        setInspectors([]);
        setCityFilter([]);
        setCouncilFilter([]);
        setPopulatedAreaFilter([]);
        setSelectedDepartmentId(null);
        setAddressFilter('');
        if (location.pathname !== "/dashboard/declinedcases" && location.pathname !== "/dashboard/failedcases") {
            setStatusFilter([]);
        }
        setCreateDateFilter(null);
        setInspectionDocumentCreateAt(null);
        setInspectionDocumentCreateAtEnd(null);
        setInspectionSertificatValidityPeriodDate(null);
        setInspectionSertificatValidityPeriodDateEnd(null);
        setInpectOrderAttachmentDate(null);
        setInpectOrderAttachmentDateEnd(null);
        setInspectionDocumentCheckDate(null);
        setInspectionDocumentCheckDateEnd(null);
        setInspectCertificateCreateDate(null);
        setInspectCertificateCreateDateEnd(null);
        setInspectionCertificateSertificatValidityPeriodDate(null);
        setInspectionCertificateSertificatValidityPeriodDateEnd(null);
        setSertificatReleaseDate(null);
        setSertificatReleaseDateEnd(null);
        setInconsistenciesNonSubstantialFilter(false);
        setInconsistenciesSubstantialFilter(false);
        setInconsistenciesCriticalFilter(false);
        setInspectionDocumentmplementation(null);
        setInspectionDocumentmplementationEnd(null);
        setCreateDateFilterEnd(null);
        setDeadlineFilter(null);
        setRoleFilter('');
        setRequestedSpeedUpFilter(null);
        setDeadlineFilterEnd(null);
        setUserFilter('');
        setInspectFileCreatorID('');
        setInspectFileCertificateCreatorID('');
        setInspectionSertificatIssuingAgency('');
        setFilterValues({});
        if (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") {
            setInputTypes([])
        }
        localStorage.removeItem(location.pathname + 'filterValues');
        localStorage.removeItem(location.pathname + 'caseNumberFilter');
        localStorage.removeItem(location.pathname + 'oldCaseNumberFilter');
        localStorage.removeItem(location.pathname + 'objectRegistryIdFilter');
        localStorage.removeItem(location.pathname + 'requestFilter');
        localStorage.removeItem(location.pathname + 'noteFilter');
        localStorage.removeItem(location.pathname + 'cadastralFilterForAnswers');
        localStorage.removeItem(location.pathname + 'globalFieldFilter');
        localStorage.removeItem(location.pathname + 'caseFileInspectFileFileFilters');
        localStorage.removeItem(location.pathname + 'inconsistenciesCritical');
        localStorage.removeItem(location.pathname + 'inspectCertificate');
        localStorage.removeItem(location.pathname + 'violationFailureToConductInspection');
        localStorage.removeItem(location.pathname + 'violationHiddenExploitation');
        localStorage.removeItem(location.pathname + 'inconsistenciesSubstantial');
        localStorage.removeItem(location.pathname + 'inconsistenciesNonSubstantial');
        localStorage.removeItem(location.pathname + 'userfullInfoFilter');
        localStorage.removeItem(location.pathname + 'requesterIdFilter');
        localStorage.removeItem(location.pathname + 'objectNameFilter');
        localStorage.removeItem(location.pathname + 'cadastralCodeFilter');
        localStorage.removeItem(location.pathname + 'addressFilter');
        localStorage.removeItem(location.pathname + 'regionFilter');
        localStorage.removeItem(location.pathname + 'inspectors');
        localStorage.removeItem(location.pathname + 'cityFilter');
        localStorage.removeItem(location.pathname + 'userIds');
        localStorage.removeItem(location.pathname + 'councilFilter');
        localStorage.removeItem(location.pathname + 'populatedAreaFilter');
        localStorage.removeItem(location.pathname + 'statusFilter');
        localStorage.removeItem(location.pathname + 'deadlineFilter');
        localStorage.removeItem(location.pathname + 'deadlineFilterEnd');
        localStorage.removeItem(location.pathname + 'createDateFilter');
        localStorage.removeItem(location.pathname + 'createDateFilterEnd');
        localStorage.removeItem(location.pathname + 'inspectionDocumentCreateAt');
        localStorage.removeItem(location.pathname + 'inspectionDocumentCreateAtEnd');
        localStorage.removeItem(location.pathname + 'inspectionSertificatValidityPeriodDate');
        localStorage.removeItem(location.pathname + 'inpectOrderAttachmentDate');
        localStorage.removeItem(location.pathname + 'inpectOrderAttachmentDateEnd');
        localStorage.removeItem(location.pathname + 'inspectionDocumentCheckDate');
        localStorage.removeItem(location.pathname + 'inspectionDocumentCheckDateEnd');
        localStorage.removeItem(location.pathname + 'inspectCertificateCreateDate');
        localStorage.removeItem(location.pathname + 'inspectCertificateCreateDateEnd');
        localStorage.removeItem(location.pathname + 'inspectionCertificateSertificatValidityPeriodDateEnd');
        localStorage.removeItem(location.pathname + 'sertificatReleaseDate');
        localStorage.removeItem(location.pathname + 'sertificatReleaseDateEnd');
        localStorage.removeItem(location.pathname + 'inconsistenciesSubstantialFilter');
        localStorage.removeItem(location.pathname + 'sertificatReleaseDateEnd');
        localStorage.removeItem(location.pathname + 'inconsistenciesNonSubstantialFilter');
        localStorage.removeItem(location.pathname + 'inspectionDocumentmplementation');
        localStorage.removeItem(location.pathname + 'inspectionDocumentmplementationEnd');
        localStorage.removeItem(location.pathname + 'selectedPermitTypeId')
        localStorage.removeItem(location.pathname + 'parentId')
        localStorage.removeItem(location.pathname + 'userFilter')
        localStorage.removeItem(location.pathname + 'inspectFileCreatorID')
        localStorage.removeItem(location.pathname + 'inspectionSertificatIssuingAgency')
        localStorage.removeItem(location.pathname + 'roleFilter')
        localStorage.removeItem(location.pathname + 'requestedSpeedUp')
        setResetFilters(true);
        setLoading(true)
    };


    useEffect(() => {
        if (resetFilters) {
            void fetchDataTable(0);
            setPage(0);
            setResetFilters(false);
            navigate(`${location.pathname}?page=0`);
        }
    }, [resetFilters, location.pathname]);


    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            navigate(`${location.pathname}?page=${newPage}`);
        }
    };


    const handleInputChange = (e, title) => {
        const newFilterValues = {...filterValues, [title]: e.target.value};
        setFilterValues(newFilterValues);
    };

    const handleDeleteModal = (caseId) => {
        setIsDeleteModalOpen(true)
        setCaseIdToDelete(caseId)
    };
    const handleCaseVisibilityModal = (caseId, isCasePublic) => {
        setIsCasePublicModalOn(true)
        setIsCasePublic(isCasePublic)
        setSelectedCaseIdForChangingPublicity(caseId)
    };

    const handleDelete = (chip) => {
        switch (chip.key) {
            case 'განაცხადის ნომერი':
                localStorage.removeItem(location.pathname + 'caseNumberFilter')
                setCaseNumberFilter('');
                break;
            case 'უწყებრივ რეესტრში რეგისტრაციის ნომერი':
                localStorage.removeItem(location.pathname + 'objectRegistryIdFilter')
                setObjectRegistryIdFilter('');
                break;
            case 'მოთხოვნა':
                localStorage.removeItem(location.pathname + 'requestFilter')
                setRequestFilter('');
                break;
            case 'ობიექტის სტატუსი':
                setCreateByExpertValue(1);
                break;
            case 'ინსპექტირების ჩაუტარებლობა დარღვევა':
                localStorage.removeItem(location.pathname + 'violationFailureToConductInspection')
                setViolationFailureToConductInspection(null);
                break;
            case 'ინსპექტირების სერთიფიკატის სახელი':
                localStorage.removeItem(location.pathname + 'inspectCertificate')
                setInspectCertificate('');
                break;

            case 'ინსპექტირების სერთიფიკატი ატვირთა':
                localStorage.removeItem(location.pathname + 'inspectFileCertificateCreatorID')
                setInspectFileCertificateCreatorID('');
                break;
            case 'ინსპექტირების ოქმი ატვირთა':
                localStorage.removeItem(location.pathname + 'inspectFileCreatorID')
                setInspectFileCreatorID('');
                break;
            case 'ფარული ექსპლუატაცია დარღვევა':
                localStorage.removeItem(location.pathname + 'violationHiddenExploitation')
                setViolationHiddenExploitation('');
                break;
            case 'ინსპექტორები':
                localStorage.removeItem(location.pathname + 'inspectors')
                setInspectors([]);
                break;
            case 'სამმართველო':
                setSelectedDepartmentId(null);
                break;
            case 'ცხრილის ტიპი':
                setTableViewOptions(1);
                break;
            case 'შენიშვნა':
                localStorage.removeItem(location.pathname + 'noteFilter')
                setNoteFilter('');
                break;
            case 'საკადასტრო კოდი':
                localStorage.removeItem(location.pathname + 'cadastralFilterForAnswers')
                setCadastralFilterForAnswers('');
                break;
            case 'ზოგადი ველი':
                localStorage.removeItem(location.pathname + 'globalFieldFilter')
                setGlobalFieldFilter('');
                break;
            case 'ობიექტი':
                localStorage.removeItem(location.pathname + 'selectedPermitTypeId')
                setSelectedPermitTypeId(null);
                break;
            case 'გამცემი ორგანო':
                localStorage.removeItem(location.pathname + 'inspectionSertificatIssuingAgency')
                setInspectionSertificatIssuingAgency(null);
                break;
            case 'განმცხადებელი':
                localStorage.removeItem(location.pathname + 'requesterIdFilter')
                setRequesterIdFilter('');
                break;
            case 'შემსრულებელი':
                localStorage.removeItem(location.pathname + 'userFilter')
                setUserFilter('');
                break;
            case 'პოზიცია':
                localStorage.removeItem(location.pathname + 'roleFilter')
                setRoleFilter('');
                break;

            case 'დაჩქარებული წესით გაცემული განაცხადები':
                localStorage.removeItem(location.pathname + 'requestedSpeedUpFilter')
                setRequestedSpeedUpFilter(null);
                break;
            case 'ატვირთვის თარიღიდან':
                localStorage.removeItem(location.pathname + 'createDateFilter');
                setCreateDateFilter(null);
                break;

            case 'ინსპექტირების სერტიფიკატის ატვირთვის თარიღამდე':
                localStorage.removeItem(location.pathname + 'inspectCertificateCreateDateEnd');
                setInspectCertificateCreateDateEnd(null);
                break;

            case 'განცხორციელების თარიღიდან':
                localStorage.removeItem(location.pathname + 'inspectionSertificatValidityPeriodDate');
                setInspectionSertificatValidityPeriodDate(null);
                break;
            case 'განცხორციელების თარიღამდე':
                localStorage.removeItem(location.pathname + 'inspectionSertificatValidityPeriodDateEnd');
                setInspectionSertificatValidityPeriodDateEnd(null);
                break;

            case 'ინსპექტირების სერტიფიკატის ატვირთვის თარიღიდან':
                localStorage.removeItem(location.pathname + 'inspectCertificateCreateDate');
                setInspectCertificateCreateDate(null);
                break;

            case 'მოქმედების ვადიდან':
                localStorage.removeItem(location.pathname + 'inspectionCertificateSertificatValidityPeriodDate');
                setInspectionCertificateSertificatValidityPeriodDate(null);
                break;

            case 'მოქმედების ვადამდე':
                localStorage.removeItem(location.pathname + 'inspectionCertificateSertificatValidityPeriodDatEnd');
                setInspectionCertificateSertificatValidityPeriodDateEnd(null);
                break;


            case 'განხორციელბის თარიღიდან':
                localStorage.removeItem(location.pathname + 'inspectionDocumentmplementation');
                setInspectionDocumentmplementation(null);
                break;
            case 'განხორციელბის თარიღამდე':
                localStorage.removeItem(location.pathname + 'inspectionDocumentmplementationEnd');
                setInspectionDocumentmplementationEnd(null);
                break;


            case 'ინსპექტირების ოქმის ატვირთვის თარიღამდე':
                localStorage.removeItem(location.pathname + 'inspectionDocumentCreateAtEnd');
                setInspectionDocumentCreateAtEnd(null);
                break;

            case 'გადამოწმების თარიღიდან':
                localStorage.removeItem(location.pathname + 'inspectionDocumentCheckDate');
                setInspectionDocumentCheckDate(null);
                break;

            case 'გადამოწმების თარიღამდე':
                localStorage.removeItem(location.pathname + 'inspectionDocumentCheckDateEnd');
                setInspectionDocumentCheckDateEnd(null);
                break;


            case 'კრიტიკული შეუსაბამომებები':
                localStorage.removeItem(location.pathname + 'inconsistenciesCritical');
                localStorage.removeItem(location.pathname + 'inconsistenciesCriticalFilter');
                setInconsistenciesCritical('');
                setInconsistenciesCriticalFilter(false);
                break;

            case 'არსებითი შეუსაბამომებები':
                localStorage.removeItem(location.pathname + 'inconsistenciesNonSubstantial');
                localStorage.removeItem(location.pathname + 'inconsistenciesSubstantialFilter');
                setInconsistenciesNonSubstantial('');
                setInconsistenciesNonSubstantialFilter(false);
                break;

            case 'არაარსებითი შეუსაბამომებები':
                localStorage.removeItem(location.pathname + 'inconsistenciesSubstantial');
                localStorage.removeItem(location.pathname + 'inconsistenciesNonSubstantialFilter');
                setInconsistenciesSubstantial('');
                setInconsistenciesNonSubstantialFilter(false);
                break;


            case 'ინსპექტირების ოქმის ატვირთვის თარიღიდან':
                localStorage.removeItem(location.pathname + 'inspectionDocumentCreateAt');
                setInspectionDocumentCreateAt(null);
                break;

            case 'დასრულების თარიღიდან':
                localStorage.removeItem(location.pathname + 'deadlineFilter');
                setDeadlineFilter(null);
                break;

            case 'დასრულების თარიღამდე':
                localStorage.removeItem(location.pathname + 'deadlineFilterEnd');
                setDeadlineFilterEnd(null);
                break;

            case 'შედგენის თარიღიდან':
                localStorage.removeItem(location.pathname + 'inpectOrderAttachmentDate');
                setInpectOrderAttachmentDate(null);
                break;
            case 'შედგენის თარიღამდე':
                localStorage.removeItem(location.pathname + 'inpectOrderAttachmentDateEnd');
                setInpectOrderAttachmentDateEnd(null);
                break;

            case 'ინსპექტირების ოქმის სახელი':
                localStorage.removeItem(location.pathname + 'caseFileInspectFileFileFilters');
                setCaseFileInspectFileFileFilters('');
                break;

            case 'სტატუსი':
                localStorage.removeItem(location.pathname + 'statusFilter');
                setStatusFilter([]);
                break;
            case 'რეგიონი':
                setRegionFilter(regionFilter.filter(id => id !== chip.id));
                localStorage.removeItem(location.pathname + 'regionFilter');
                localStorage.setItem(location.pathname + 'regionFilter', JSON.stringify(regionFilter.filter(id => id !== chip.id)));
                setCouncilFilter([]);
                setCityFilter([]);
                setPopulatedAreaFilter([]);
                break;
            case 'მუნიციპალიტეტი':

                setCityFilter(cityFilter.filter(id => id !== chip.id));
                localStorage.removeItem(location.pathname + 'cityFilter');
                localStorage.setItem(location.pathname + 'cityFilter', JSON.stringify(cityFilter.filter(id => id !== chip.id)));
                setCouncilFilter([]);
                setPopulatedAreaFilter([]);
                break;
            case 'საკონსულო':

                setCouncilFilter(councilFilter.filter(id => id !== chip.id));
                localStorage.removeItem(location.pathname + 'councilFilter');
                localStorage.setItem(location.pathname + 'councilFilter', JSON.stringify(councilFilter.filter(id => id !== chip.id)));
                setPopulatedAreaFilter([]);
                break;
            case 'დასახლებული პუნქტი':

                setPopulatedAreaFilter(populatedAreaFilter.filter(id => id !== chip.id));
                localStorage.removeItem(location.pathname + 'populatedAreaFilter');
                localStorage.setItem(location.pathname + 'populatedAreaFilter', JSON.stringify(populatedAreaFilter.filter(id => id !== chip.id)));
                break;
            default:
                const newFilterValues = {...filterValues};
                if (newFilterValues[chip.key] !== undefined) {
                    newFilterValues[chip.key] = '';
                    setFilterValues(newFilterValues);
                }
                break;
        }
        setResetFilters(true);

    };

    const buildRequestBody = (isExcel = false) => {
        const filters = [];

        const addFilter = (name, value, type = 'string', dynamic = false, greaterDateTime = false) => {
            if (value || value === 0) {
                let filterValue;
                if (type === 'dateTime') {
                    filterValue = value instanceof Date ? value.toISOString() : value;
                } else {
                    filterValue = value;
                }

                filters.push({
                    fieldName: name,
                    [`${type}Value`]: filterValue,
                    dynamic,
                    greaterDateTime
                });
            }
        };

        addFilter('caseNumber', caseNumberFilter);
        addFilter('request', requestFilter);
        addFilter('note', noteFilter);
        addFilter('userfullInfo', userfullInfoFilter);
        addFilter('ObjectName', objectNameFilter);
        if (regionFilter.length > 0) {
            regionFilter.forEach(region => addFilter('Region', `-${region}-`, 'string', false));
        }
        if (cityFilter.length > 0) {
            cityFilter.forEach(city => addFilter('City', `-${city}-`, 'string', false));
        }
        if (councilFilter.length > 0) {
            councilFilter.forEach(council => addFilter('Council', `-${council}-`, 'string', false));
        }
        if (populatedAreaFilter.length > 0) {
            populatedAreaFilter.forEach(popArea => addFilter('populatedArea', `-${popArea}-`, 'string', false));
        }
        addFilter('Address', addressFilter);
        addFilter('CreateDate', createDateFilter, 'dateTime', false, true);
        addFilter('inspectionDocumentmplementation', inspectionDocumentmplementationEnd, 'dateTime', false);
        addFilter('inspectionDocumentmplementation', inspectionDocumentmplementation, 'dateTime', false, true);
        addFilter('CreateDate', createDateFilterEnd, 'dateTime');
        addFilter('Dedline', deadlineFilter, 'dateTime', false, true);
        addFilter('Dedline', deadlineFilterEnd, 'dateTime', false);

        inputTypes.forEach(inputType => {
            const value = filterValues[inputType.title];
            if (value) {
                addFilter(inputType.title, value, 'string', true);
            }
        });

        const sort = [];
        if (sortField && !isExcel) {
            sort.push({
                fieldName: sortField,
                desc: sortOrder
            });
        }

        const requestBody = {
            pageSize,
            page,
            sort,
            filter: filters,

        };

        if (!requestBody.caseFileInspectFileFileFilters) {
            requestBody.caseFileInspectFileFileFilters = {};
        }
        if (!requestBody.caseFileSertificatFileFilters) {
            requestBody.caseFileSertificatFileFilters = {};
        }


        if (selectedPermitTypeId !== null) {
            requestBody.permitTypeId = selectedPermitTypeId;
        }
        if (cadastralFilterForAnswers !== null) {
            requestBody.cadastralCode = cadastralFilterForAnswers;
        }

        if (caseFileInspectFileFileFilters !== '') {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                name: caseFileInspectFileFileFilters
            }
        }
        if (inconsistenciesCritical !== '') {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                inconsistenciesCritical: inconsistenciesCritical
            };
        }

        if (inconsistenciesNonSubstantial !== '') {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                inconsistenciesSubstantial: inconsistenciesNonSubstantial
            };
        }
        if (inconsistenciesSubstantial !== '') {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                inconsistenciesNonSubstantial: inconsistenciesSubstantial
            };
        }
        if (violationFailureToConductInspection !== null) {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                violationFailureToConductInspection: violationFailureToConductInspection
            };
        }
        if (violationHiddenExploitation !== '') {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                violationHiddenExploitation: violationHiddenExploitation
            };
        }
        if (inspectFileCreatorID !== '') {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                creatorId: inspectFileCreatorID
            };
        }
        if (statusFilter.length > 0) {
            if (userRole === "USER" || userRole === null) {
                requestBody.statuses = findMatchingStatusesById(statusFilter);
            } else {
                requestBody.statuses = findMatchingInternalStatusesById(statusFilter);
            }

        }

        if (inspectCertificate !== '') {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            requestBody.caseFileSertificatFileFilters = {
                ...requestBody.caseFileSertificatFileFilters,
                name: inspectCertificate
            };
        }
        if (inspectionSertificatIssuingAgency !== '') {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            requestBody.caseFileSertificatFileFilters = {
                ...requestBody.caseFileSertificatFileFilters,
                inspectionSertificatIssuingAgency: inspectionSertificatIssuingAgency
            };
        }
        if (inspectFileCertificateCreatorID !== '') {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            requestBody.caseFileSertificatFileFilters = {
                ...requestBody.caseFileSertificatFileFilters,
                creatorId: inspectFileCertificateCreatorID
            };
        }
        if (inspectionDocumentCreateAt !== null || inspectionDocumentCreateAtEnd !== null) {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileInspectFileFileFilters = {
                createAt: {
                    ...requestBody.caseFileInspectFileFileFilters,
                    from: inspectionDocumentCreateAt instanceof Date ? addOneDay(inspectionDocumentCreateAt) : (inspectionDocumentCreateAt || defaultStart),
                    to: inspectionDocumentCreateAtEnd instanceof Date ? addOneDay(inspectionDocumentCreateAtEnd) : (inspectionDocumentCreateAtEnd || defaultEnd)
                }
            };
        }

        if (inspectionSertificatValidityPeriodDate !== null || inspectionSertificatValidityPeriodDateEnd !== null) {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileSertificatFileFilters = {
                inspectionSertificatValidityPeriodDate: {
                    ...requestBody.caseFileSertificatFileFilters,
                    from: inspectionSertificatValidityPeriodDate instanceof Date ? addOneDay(inspectionSertificatValidityPeriodDate) : (inspectionSertificatValidityPeriodDate || defaultStart),
                    to: inspectionSertificatValidityPeriodDateEnd instanceof Date ? addOneDay(inspectionSertificatValidityPeriodDateEnd) : (inspectionSertificatValidityPeriodDateEnd || defaultEnd)
                }
            };
        }

        if (inpectOrderAttachmentDate !== null || inpectOrderAttachmentDateEnd !== null) {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.inpectOrderAttachment = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileSertificatFileFilters = {
                inspectionSertificatValidityPeriodDate: {
                    ...requestBody.caseFileSertificatFileFilters,
                    from: inpectOrderAttachmentDate instanceof Date ? addOneDay(inpectOrderAttachmentDate) : (inpectOrderAttachmentDate || defaultStart),
                    to: inpectOrderAttachmentDateEnd instanceof Date ? addOneDay(inpectOrderAttachmentDateEnd) : (inpectOrderAttachmentDateEnd || defaultEnd)
                }
            };
        }

        if (inspectCertificateCreateDate !== null || inspectCertificateCreateDateEnd !== null) {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileInspectFileFileFilters = {
                createAt: {
                    ...requestBody.caseFileInspectFileFileFilters,
                    from: inspectCertificateCreateDate instanceof Date ? addOneDay(inspectCertificateCreateDate) : (inspectCertificateCreateDate || defaultStart),
                    to: inspectCertificateCreateDateEnd instanceof Date ? addOneDay(inspectCertificateCreateDateEnd) : (inspectCertificateCreateDateEnd || defaultEnd)
                }
            };
        }
        if (inspectionCertificateSertificatValidityPeriodDate !== null || inspectionCertificateSertificatValidityPeriodDatEnd !== null) {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileSertificatFileFilters = {
                inspectionSertificatValidityPeriodDate: {
                    ...requestBody.caseFileSertificatFileFilters,
                    from: inspectionCertificateSertificatValidityPeriodDate instanceof Date ? addOneDay(inspectionCertificateSertificatValidityPeriodDate) : (inspectionCertificateSertificatValidityPeriodDate || defaultStart),
                    to: inspectionCertificateSertificatValidityPeriodDatEnd instanceof Date ? addOneDay(inspectionCertificateSertificatValidityPeriodDatEnd) : (inspectionCertificateSertificatValidityPeriodDatEnd || defaultEnd)
                }
            };
        }


        if (inspectionDocumentCheckDate !== null || inspectionDocumentCheckDateEnd !== null) {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileInspectFileFileFilters = {
                inspectionDocumentCheckingDate: {
                    ...requestBody.caseFileInspectFileFileFilters,
                    from: inspectionDocumentCheckDate instanceof Date ? addOneDay(inspectionDocumentCheckDate) : (inspectionDocumentCheckDate || defaultStart),
                    to: inspectionDocumentCheckDateEnd instanceof Date ? addOneDay(inspectionDocumentCheckDateEnd) : (inspectionDocumentCheckDateEnd || defaultEnd)
                }
            };
        }

        if (sertificatReleaseDate !== null || sertificatReleaseDateEnd !== null) {
            requestBody.filterBycaseFileSertificatFileFilter = true;
            const defaultStart = new Date('1970-01-01').toISOString();
            const defaultEnd = new Date('2090-01-01').toISOString();

            const addOneDay = (date) => {
                const result = new Date(date);
                result.setDate(result.getDate() + 2);
                return result.toISOString();
            };

            requestBody.caseFileSertificatFileFilters = {
                sertificatReleaseDate: {
                    ...requestBody.caseFileSertificatFileFilters,
                    from: sertificatReleaseDate instanceof Date ? addOneDay(sertificatReleaseDate) : (sertificatReleaseDate || defaultStart),
                    to: sertificatReleaseDateEnd instanceof Date ? addOneDay(sertificatReleaseDateEnd) : (sertificatReleaseDateEnd || defaultEnd)
                }
            };
        }
        if (inconsistenciesCriticalFilter) {
            requestBody.inconsistenciesCriticalFilter = inconsistenciesCriticalFilter
        }
        if (inconsistenciesNonSubstantialFilter) {
            requestBody.inconsistenciesNonSubstantialFilter = inconsistenciesNonSubstantialFilter
        }
        if (inconsistenciesSubstantialFilter) {
            requestBody.inconsistenciesSubstantialFilter = inconsistenciesSubstantialFilter
        }


        if (userFilter) {
            requestBody.activeUserId = userFilter;
        }


        if (inspectors.length !== 0) {
            requestBody.filterByCaseFileInspectFileFileFilter = true;
            requestBody.caseFileInspectFileFileFilters = {
                ...requestBody.caseFileInspectFileFileFilters,
                expertIdsWhoWorking: inspectors
            };
        }

        if (globalFieldFilter) {
            requestBody.likeSearchValue = globalFieldFilter
            requestBody.dataKEy = getCheckedFieldsForSearch();
        }

        if (oldCaseNumberFilter) {
            requestBody.oldCaseNumber = oldCaseNumberFilter;
        }

        if (objectRegistryIdFilter) {
            requestBody.searchObjectRegistryID = objectRegistryIdFilter;
        }

        if (roleFilter) {
            const filteredUsers = users.filter(user => user.roleName.toLowerCase() === roleFilter.toLowerCase());
            requestBody.caseUserUsersIds = filteredUsers.map(user => user.id);
        }

        if (requestedSpeedUpFilter !== null) {
            requestBody.requestedSpeedUp = requestedSpeedUpFilter;
        }

        if (selectedDepartmentId !== null) {
            if (selectedDepartmentId === 1) {
                requestBody.pertmiTypeIdList = buildingDepartments
            } else if (selectedDepartmentId === 2) {
                requestBody.pertmiTypeIdList = explotionDepartments
            } else if (selectedDepartmentId === 3) {
                requestBody.pertmiTypeIdList = objectRegisteryDepartments
            }
        } else {
            requestBody.pertmiTypeIdList = null
        }

        if (location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry" || location.pathname === "/dashboard/objectregistrationtable") {
            requestBody.pertmiTypeIdList = selectedPermitTypeId !== null ? [selectedPermitTypeId] : lastChildren.map(({id}) => id);
        }
        if (requesterIdFilter) {
            if (userIds.length !== 0) {
                requestBody.caseRequesterIds = userIds.map(user => user.id);
            } else {
                requestBody.caseRequesterIds = ["NOT FOUND"]
            }

        }
        if (isExcel) {
            requestBody.dataKEy = getCheckedFields();
        }
        return requestBody;
    };


    useEffect(() => {
        const loadInitialFilters = async () => {
            const savedFilterValues = localStorage.getItem(location.pathname + 'filterValues');
            const savedSelectedPermitTypeId = localStorage.getItem(location.pathname + 'selectedPermitTypeId');
            const savedCaseNumberFilter = localStorage.getItem(location.pathname + 'caseNumberFilter');
            const savedOldCaseNumberFilter = localStorage.getItem(location.pathname + 'oldCaseNumberFilter');
            const savedObjectRegistryIdFilter = localStorage.getItem(location.pathname + 'objectRegistryIdFilter');
            const savedRequestFilter = localStorage.getItem(location.pathname + 'requestFilter');
            const savedNoteFilter = localStorage.getItem(location.pathname + 'noteFilter');
            const cadastralFilter = localStorage.getItem(location.pathname + 'cadastralFilterForAnswers');
            const savedGlobalFieldFilter = localStorage.getItem(location.pathname + 'globalFieldFilter');
            const savedCaseFileInspectFileFileFilters = localStorage.getItem(location.pathname + 'caseFileInspectFileFileFilters');
            const savedInconsistenciesCritical = localStorage.getItem(location.pathname + 'inconsistenciesCritical');
            const savedInspectCertificate = localStorage.getItem(location.pathname + 'inspectCertificate');
            const savedViolationFailureToConductInspection = localStorage.getItem(location.pathname + 'violationFailureToConductInspection');
            const savedViolationHiddenExploitation = localStorage.getItem(location.pathname + 'violationHiddenExploitation');
            const savedInconsistenciesSubstantial = localStorage.getItem(location.pathname + 'inconsistenciesSubstantial');
            const savedInconsistenciesNonSubstantial = localStorage.getItem(location.pathname + 'inconsistenciesNonSubstantial');
            const saveduserfullInfoFilter = localStorage.getItem(location.pathname + 'userfullInfoFilter');
            const savedCityFilter = localStorage.getItem(location.pathname + 'cityFilter');
            const savedCouncilFilter = localStorage.getItem(location.pathname + 'councilFilter');
            const savedPopulatedAreaFilter = localStorage.getItem(location.pathname + 'populatedAreaFilter');
            const savedStatusFilter = localStorage.getItem(location.pathname + 'statusFilter');
            const savedRegionFilter = localStorage.getItem(location.pathname + 'regionFilter');
            const savedInspectors = localStorage.getItem(location.pathname + 'inspectors');
            const savedAddressFilter = localStorage.getItem(location.pathname + 'addressFilter');
            const savedCadastralFilter = localStorage.getItem(location.pathname + 'cadastralCodeFilter');
            const savedObjectNameFilter = localStorage.getItem(location.pathname + 'objectNameFilter');
            const savedRequesterNameFilter = localStorage.getItem(location.pathname + 'requesterIdFilter');
            const savedCreateDate = localStorage.getItem(location.pathname + 'createDateFilter');
            const savedInspectionDocumentCreateAt = localStorage.getItem(location.pathname + 'inspectionDocumentCreateAt');
            const savedInspectionDocumentCreateAtEnd = localStorage.getItem(location.pathname + 'inspectionDocumentCreateAtEnd');
            const savedInspectionSertificatValidityPeriodDate = localStorage.getItem(location.pathname + 'inspectionSertificatValidityPeriodDate');
            const savedInspectionSertificatValidityPeriodDateEnd = localStorage.getItem(location.pathname + 'inspectionSertificatValidityPeriodDateEnd');
            const savedInpectOrderAttachmentDate = localStorage.getItem(location.pathname + 'inpectOrderAttachmentDate');
            const savedInpectOrderAttachmentDateEnd = localStorage.getItem(location.pathname + 'inpectOrderAttachmentDateEnd');
            const savedInspectionDocumentCheckDateEnd = localStorage.getItem(location.pathname + 'inspectionDocumentCheckDateEnd');
            const savedInspectCertificateCreateDate = localStorage.getItem(location.pathname + 'inspectCertificateCreateDate');
            const savedInspectCertificateCreateDateEnd = localStorage.getItem(location.pathname + 'inspectCertificateCreateDateEnd');
            const savedInspectionCertificateSertificatValidityPeriodDateEnd = localStorage.getItem(location.pathname + 'inspectionCertificateSertificatValidityPeriodDateEnd');
            const savedSertificatReleaseDate = localStorage.getItem(location.pathname + 'sertificatReleaseDate');
            const savedSertificatReleaseDateEnd = localStorage.getItem(location.pathname + 'sertificatReleaseDateEnd');
            const savedInconsistenciesCriticalFilter = localStorage.getItem(location.pathname + 'inconsistenciesCriticalFilter');
            const savedInconsistenciesNonSubstantialFilter = localStorage.getItem(location.pathname + 'inconsistenciesNonSubstantialFilter');
            const savedInconsistenciesSubstantialFilter = localStorage.getItem(location.pathname + 'savedInconsistenciesSubstantialFilter');
            const savedInspectionDocumentCheckDate = localStorage.getItem(location.pathname + 'inspectionDocumentCheckDate');
            const savedInspectionDocumentmplementation = localStorage.getItem(location.pathname + 'inspectionDocumentmplementation');
            const savedInspectionDocumentmplementationEnd = localStorage.getItem(location.pathname + 'inspectionDocumentmplementationEnd');
            const savedCreateDateEnd = localStorage.getItem(location.pathname + 'createDateFilterEnd');
            const savedDeadline = localStorage.getItem(location.pathname + 'deadlineFilter');
            const savedUserFilter = localStorage.getItem(location.pathname + 'userFilter');
            const savedInspectFileCreatorID = localStorage.getItem(location.pathname + 'inspectFileCreatorID');
            const savedInspectFileCertificateCreatorID = localStorage.getItem(location.pathname + 'inspectFileCertificateCreatorID');
            const savedInspectionSertificatIssuingAgency = localStorage.getItem(location.pathname + 'inspectionSertificatIssuingAgency');
            const savedRoleFilter = localStorage.getItem(location.pathname + 'roleFilter');
            const savedRequestedSpeedUp = localStorage.getItem(location.pathname + 'requestedSpeedUp');
            const savedUserIds = localStorage.getItem('userIds');

            if (savedUserIds) {
                setUserIds(JSON.parse(savedUserIds));
            }
            if (savedUserFilter) {
                setUserFilter(savedUserFilter);
            }
            if (savedRequestedSpeedUp && savedRequestedSpeedUp !== "null") {
                setRequestedSpeedUpFilter(savedRequestedSpeedUp);
            }
            if (savedInspectFileCreatorID) {
                setInspectFileCreatorID(savedInspectFileCreatorID);
            }
            if (savedInspectFileCertificateCreatorID) {
                setInspectFileCertificateCreatorID(savedInspectFileCertificateCreatorID);
            }
            if (savedInspectionSertificatIssuingAgency) {
                setInspectionSertificatIssuingAgency(savedInspectionSertificatIssuingAgency);
            }
            if (savedRoleFilter) {
                setRoleFilter(savedRoleFilter);
            }


            if (savedSelectedPermitTypeId) {
                setSelectedPermitTypeId(JSON.parse(savedSelectedPermitTypeId));
            }
            if (savedFilterValues) {
                setFilterValues(JSON.parse(savedFilterValues));
            }
            if (savedCaseNumberFilter) {
                setCaseNumberFilter(savedCaseNumberFilter);
            }
            if (savedOldCaseNumberFilter) {
                setOldCaseNumberFilter(savedOldCaseNumberFilter);
            }
            if (savedObjectRegistryIdFilter) {
                setObjectRegistryIdFilter(savedObjectRegistryIdFilter);
            }
            if (savedRequestFilter) {
                setRequestFilter(savedRequestFilter);
            }
            if (savedNoteFilter) {
                setNoteFilter(savedNoteFilter);
            }
            if (cadastralFilter) {
                setCadastralFilterForAnswers(cadastralFilter);
            }
            if (savedGlobalFieldFilter) {
                setGlobalFieldFilter(savedGlobalFieldFilter);
            }
            if (savedCaseFileInspectFileFileFilters) {
                setCaseFileInspectFileFileFilters(savedCaseFileInspectFileFileFilters);
            }
            if (savedInconsistenciesCritical) {
                setInconsistenciesCritical(savedInconsistenciesCritical);
            }
            if (savedInspectCertificate) {
                setInspectCertificate(savedInspectCertificate);
            }
            if (savedViolationFailureToConductInspection) {
                setViolationFailureToConductInspection(violationFailureToConductInspection);
            }
            if (savedViolationHiddenExploitation) {
                setViolationHiddenExploitation(savedViolationHiddenExploitation);
            }
            if (savedInconsistenciesSubstantial) {
                setInconsistenciesSubstantial(inconsistenciesSubstantial);
            }
            if (savedInconsistenciesNonSubstantial) {
                setInconsistenciesNonSubstantial(savedInconsistenciesNonSubstantial);
            }
            if (saveduserfullInfoFilter) {
                setUserfullInfoFilter(saveduserfullInfoFilter);
            }
            if (savedPopulatedAreaFilter) {
                setPopulatedAreaFilter(JSON.parse(savedPopulatedAreaFilter));
            }
            if (savedCityFilter) {
                setCityFilter(JSON.parse(savedCityFilter));
            }
            if (savedStatusFilter) {
                setStatusFilter(JSON.parse(savedStatusFilter));
            }
            if (savedRegionFilter) {
                setRegionFilter(JSON.parse(savedRegionFilter));
            }
            if (savedInspectors) {
                setInspectors(JSON.parse(savedInspectors));
            }
            if (savedAddressFilter) {
                setAddressFilter(savedAddressFilter);
            }
            if (savedCadastralFilter) {
                setCadastralCodeFilter(savedCadastralFilter);
            }
            if (savedObjectNameFilter) {
                setObjectNameFilter(savedObjectNameFilter);
            }
            if (savedRequesterNameFilter) {
                setRequesterIdFilter(savedRequesterNameFilter);
            }
            if (savedCouncilFilter) {
                setCouncilFilter(JSON.parse(savedCouncilFilter));
            }
            if (savedCreateDate) {
                setCreateDateFilter(new Date(savedCreateDate));
            }

            if (savedInspectionDocumentCreateAt) {
                setInspectionDocumentCreateAt(new Date(savedInspectionDocumentCreateAt));
            }
            if (savedInspectionDocumentCreateAtEnd) {
                setInspectionDocumentCreateAtEnd(new Date(savedInspectionDocumentCreateAtEnd));
            }
            if (savedInspectionSertificatValidityPeriodDate) {
                setInspectionSertificatValidityPeriodDate(new Date(savedInspectionSertificatValidityPeriodDate));
            }
            if (savedInspectionSertificatValidityPeriodDateEnd) {
                setInspectionSertificatValidityPeriodDateEnd(new Date(savedInspectionSertificatValidityPeriodDateEnd));
            }
            if (savedInpectOrderAttachmentDateEnd) {
                setInpectOrderAttachmentDateEnd(new Date(savedInpectOrderAttachmentDateEnd));
            }
            if (savedInpectOrderAttachmentDate) {
                setInpectOrderAttachmentDate(new Date(savedInpectOrderAttachmentDate));
            }
            if (savedInspectionDocumentCheckDate) {
                setInspectionDocumentCheckDate(new Date(savedInspectionDocumentCheckDate));
            }
            if (savedInspectionDocumentCheckDateEnd) {
                setInspectionDocumentCheckDateEnd(new Date(savedInspectionDocumentCheckDateEnd));
            }
            if (savedInspectCertificateCreateDate) {
                setInspectCertificateCreateDate(new Date(savedInspectCertificateCreateDate));
            }
            if (savedInspectCertificateCreateDateEnd) {
                setInspectCertificateCreateDateEnd(new Date(savedInspectCertificateCreateDateEnd));
            }
            if (savedInspectionCertificateSertificatValidityPeriodDateEnd) {
                setInspectionCertificateSertificatValidityPeriodDateEnd(new Date(savedInspectionCertificateSertificatValidityPeriodDateEnd));
            }
            if (savedSertificatReleaseDate) {
                setSertificatReleaseDate(new Date(savedSertificatReleaseDate));
            }
            if (savedSertificatReleaseDateEnd) {
                setSertificatReleaseDateEnd(new Date(savedSertificatReleaseDateEnd));
            }
            if (savedInconsistenciesCriticalFilter) {
                setInconsistenciesCriticalFilter(true)
            }
            if (savedInconsistenciesNonSubstantialFilter) {
                setInconsistenciesNonSubstantialFilter(true)
            }
            if (savedInconsistenciesSubstantialFilter) {
                setInconsistenciesSubstantialFilter(true)
            }
            if (savedInspectionDocumentmplementation) {
                setInspectionDocumentmplementation(new Date(savedInspectionDocumentmplementation));
            }
            if (savedInspectionDocumentmplementationEnd) {
                setInspectionDocumentmplementationEnd(new Date(savedInspectionDocumentmplementationEnd));
            }
            if (savedCreateDateEnd) {
                setCreateDateFilterEnd(new Date(savedCreateDate));
            }
            if (savedDeadline) {
                setDeadlineFilterEnd(new Date(savedDeadline));
            }

            setInitialSetupComplete(true);
        };

        void loadInitialFilters();
    }, [selectedPermitTypeId]);


    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return '';
        }
        const date = new Date(dateString);
        if (isNaN(date)) {
            return '';
        }
        if (dateString === null) {
            return ''
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };


    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
    };


    const parentTitles = {};
    parentList.forEach(parent => {
        parentTitles[parent.id] = parent.description;
    });


    useEffect(() => {
        const savedSelectedPermitTypeId = localStorage.getItem('selectedPermitTypeId');
        const savedParentId = localStorage.getItem('parentId');
        if (savedSelectedPermitTypeId) {
            setSelectedPermitTypeId(JSON.parse(savedSelectedPermitTypeId));
        }
        if (savedParentId && (location.pathname !== "/dashboard/registery" || location.pathname !== "/objectregistry")) {
            setParentId(JSON.parse(savedParentId))
        }
    }, []);

    useEffect(() => {
        if (location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") {
            setParentId(40)
        }
    }, [parentId]);


    const saveFiltersToLocalStorage = () => {
        localStorage.setItem(location.pathname + 'filterValues', JSON.stringify(filterValues));
        localStorage.setItem(location.pathname + 'caseNumberFilter', caseNumberFilter);
        localStorage.setItem(location.pathname + 'oldCaseNumberFilter', oldCaseNumberFilter);
        localStorage.setItem(location.pathname + 'objectRegistryIdFilter', objectRegistryIdFilter);
        localStorage.setItem(location.pathname + 'requestFilter', requestFilter);
        localStorage.setItem(location.pathname + 'noteFilter', noteFilter);
        localStorage.setItem(location.pathname + 'cadastralFilterForAnswers', cadastralFilterForAnswers);
        localStorage.setItem(location.pathname + 'globalFieldFilter', globalFieldFilter);
        localStorage.setItem(location.pathname + 'caseFileInspectFileFileFilters', caseFileInspectFileFileFilters);
        localStorage.setItem(location.pathname + 'inconsistenciesCritical', inconsistenciesCritical);
        localStorage.setItem(location.pathname + 'inspectCertificate', inspectCertificate);
        localStorage.setItem(location.pathname + 'violationFailureToConductInspection', violationFailureToConductInspection);
        localStorage.setItem(location.pathname + 'violationHiddenExploitation', violationHiddenExploitation);
        localStorage.setItem(location.pathname + 'inconsistenciesSubstantial', inconsistenciesSubstantial);
        localStorage.setItem(location.pathname + 'userfullInfoFilter', userfullInfoFilter);
        localStorage.setItem(location.pathname + 'requesterIdFilter', requesterIdFilter);
        localStorage.setItem(location.pathname + 'cadastralCodeFilter', cadastralCodeFilter);
        localStorage.setItem(location.pathname + 'addressFilter', addressFilter);
        localStorage.setItem(location.pathname + 'objectNameFilter', objectNameFilter);
        localStorage.setItem(location.pathname + 'regionFilter', JSON.stringify(regionFilter));
        localStorage.setItem(location.pathname + 'inspectors', JSON.stringify(inspectors));
        localStorage.setItem(location.pathname + 'cityFilter', JSON.stringify(cityFilter));
        localStorage.setItem(location.pathname + 'councilFilter', JSON.stringify(councilFilter));
        localStorage.setItem(location.pathname + 'populatedAreaFilter', JSON.stringify(populatedAreaFilter));
        localStorage.setItem(location.pathname + 'statusFilter', JSON.stringify(statusFilter));
        localStorage.setItem(location.pathname + 'userFilter', userFilter);
        localStorage.setItem(location.pathname + 'inspectFileCreatorID', inspectFileCreatorID);
        localStorage.setItem(location.pathname + 'inspectFileCertificateCreatorID', inspectFileCertificateCreatorID);
        localStorage.setItem(location.pathname + 'inspectionSertificatIssuingAgency', inspectionSertificatIssuingAgency);
        localStorage.setItem(location.pathname + 'roleFilter', roleFilter);
        localStorage.setItem(location.pathname + 'requestedSpeedUp', requestedSpeedUpFilter);
        localStorage.setItem(location.pathname + 'userIds', JSON.stringify(userIds));

    };

    const handleCaseNumberChange = (e) => {
        const newValue = e.target.value;
        setCaseNumberFilter(newValue);
    }


    const handleObjectRegistryIdFilter = (e) => {
        const newValue = e.target.value;
        setObjectRegistryIdFilter(newValue);
    };
    const handleRequestFilter = (e) => {
        const newValue = e.target.value;
        setRequestFilter(newValue);
    };

    const handleNoteChange = (e) => {
        const newValue = e.target.value;
        setNoteFilter(newValue);
    };

    const handleCadastralCodeChange = (e) => {
        const newValue = e.target.value;
        setCadastralFilterForAnswers(newValue);
    };

    const handleGlobalFieldChange = (e) => {
        const newValue = e.target.value;
        setGlobalFieldFilter(newValue);
    };

    const handleCaseFileInspectFileFileFilters = (e) => {
        const newValue = e.target.value;
        setCaseFileInspectFileFileFilters(newValue);
    };
    const handleInconsistenciesCritical = (e) => {
        const newValue = e.target.value;
        setInconsistenciesCritical(newValue);
    };
    const handleInspectCertificate = (e) => {
        const newValue = e.target.value;
        setInspectCertificate(newValue);
    };
    const handleInspectionSertificatIssuingAgency = (e) => {
        const newValue = e.target.value;
        setInspectionSertificatIssuingAgency(newValue);
    };


    const handleInconsistenciesSubstantial = (e) => {
        const newValue = e.target.value;
        setInconsistenciesSubstantial(newValue);
    };

    const handleInconsistenciesNonSubstantial = (e) => {
        const newValue = e.target.value;
        setInconsistenciesNonSubstantial(newValue);
    };
    const handleRegionChange = (event) => {
        const newValue = event.target.value;
        setRegionFilter(newValue);


        if (newValue.length > 0) {
            const fetchCitiesForRegions = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCities(response.data.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    setCities([]);
                }
            };

            void fetchCitiesForRegions();
        } else {
            setCities([]);
        }
    };

    const handleInspectorsChange = (event) => {
        const newValue = event.target.value;
        setInspectors(newValue);

    };


    useEffect(() => {
        if (searchByRowEvent) {
            if (cadastralCodeFilter) {
                void fetchDataTable();
            }
            if (objectNameFilter) {
                void fetchDataTable()
            }
            if (regionFilter) {
                void fetchDataTable()
            }
            if (cityFilter) {
                void fetchDataTable()
            }
            if (councilFilter) {
                void fetchDataTable()
            }
            if (addressFilter) {
                void fetchDataTable()
            }
            if (populatedAreaFilter) {
                void fetchDataTable()
            }
            if (statusFilter) {
                void fetchDataTable()
            }
        }
        setSearchByRowEvent(false)
    }, [cadastralCodeFilter, objectNameFilter, regionFilter, cityFilter, addressFilter, statusFilter, cityFilter, populatedAreaFilter, page]);

    useEffect(() => {
        const fetchCitiesForRegion = async () => {
            if (regionFilter.length > 0 && geoIds) {
                try {

                    const dictionaryRequests = regionFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCities(response.data.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    setCities([]);
                }
            } else {
                setCities([]);
            }
        };

        void fetchCitiesForRegion();
    }, [regionFilter, geoIds]);


    useEffect(() => {
        const fetchCouncisForCities = async () => {
            if (cityFilter.length > 0 && geoIds) {
                try {
                    const dictionaryRequests = cityFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCouncils(response.data.data);
                    } else {
                        setCouncils([]);
                    }
                } catch (error) {
                    setCouncils([]);
                }
            } else {
                setCouncils([]);
            }
        };
        void fetchCouncisForCities();
    }, [cityFilter, geoIds]);


    useEffect(() => {
        const fetchPopulatedAreasForCouncils = async () => {
            if (councilFilter.length > 0 && geoIds) {
                try {

                    const dictionaryRequests = councilFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.cityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setPopulatedAres(response.data.data);
                    } else {
                        setPopulatedAres([]);
                    }
                } catch (error) {
                    setPopulatedAres([]);
                }
            } else {
                setPopulatedAres([]);
            }
        };
        void fetchPopulatedAreasForCouncils();
    }, [councilFilter, geoIds]);


    const handleCityChange = (event) => {
        const newValue = event.target.value;
        setCityFilter(newValue);

        if (newValue.length > 0) {
            const fetchCouncilsForCities = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCouncils(response.data.data);
                    } else {
                        setCouncils([]);
                    }
                } catch (error) {
                    setCouncils([]);
                }
            };

            void fetchCouncilsForCities();
        } else {
            setCouncils([]);
        }
    };
    const handleCouncilChange = (event) => {
        const newValue = event.target.value;
        setCouncilFilter(newValue);

        if (newValue.length > 0) {
            const fetchCitiesForRegions = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.cityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setPopulatedAres(response.data.data);
                    } else {
                        setPopulatedAres([]);
                    }
                } catch (error) {
                    setPopulatedAres([]);
                }
            };

            void fetchCitiesForRegions();
        } else {
            setPopulatedAres([]);
        }
    };
    const handlePopulatedAreaChange = (event) => {
        const newValue = event.target.value;
        setPopulatedAreaFilter(newValue);
    };
    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };


    const handleViolationFailureToConductInspection = (e) => {
        const newValue = e.target.value;
        setViolationFailureToConductInspection(newValue);
    };

    const handleViolationHiddenExploitation = (e) => {
        const newValue = e.target.value;
        setViolationHiddenExploitation(newValue);
    };
    const handleUserChange = (event, newValue) => {
        if (newValue) {
            const newUserId = newValue.id;
            setUserFilter(newUserId);
        } else {
            setUserFilter('');
        }
    };

    const handleInspectUserChange = (event, newValue) => {
        if (newValue) {
            const newUserId = newValue.id;
            setInspectFileCreatorID(newUserId);
        } else {
            setInspectFileCreatorID('');
        }
    };
    const handleInspectCertificateUserChange = (event, newValue) => {
        if (newValue) {
            const newUserId = newValue.id;
            setInspectFileCertificateCreatorID(newUserId);
        } else {
            setInspectFileCertificateCreatorID('');
        }
    };


    const handleRoleChange = (e) => {
        const newRoleFilter = e.target.value;

        setRoleFilter(newRoleFilter);
        const usersWithRole = usersMain.filter(user => user.roleName === newRoleFilter)
        if (usersWithRole.filter(user => user.id === userFilter).length === 0) {
            setUserFilter('')
        }
        setUsers(usersWithRole)
    };

    const handleRequestSpeedUp = (e) => {

        if (e.target.value === "false") {
            setRequestedSpeedUpFilter(false);
        } else if (e.target.value === "true") {
            setRequestedSpeedUpFilter(true);
        } else {
            setRequestedSpeedUpFilter(null);
        }

    };

    useEffect(() => {
        if (roleFilter === '') {
            setUsers(usersMain)
        }
    }, [roleFilter]);
    const handleCreateDateChange = (date) => {
        setCreateDateFilter(date);
    };

    const handleInspectionCreatedAt = (date) => {
        setInspectionDocumentCreateAt(date);
    };
    const handleInspectionCreatedAtEnd = (date) => {
        setInspectionDocumentCreateAtEnd(date);
    };
    const handleInspectionSertificatValidityPeriodDate = (date) => {
        setInspectionSertificatValidityPeriodDate(date);
    };
    const handleInspectionSertificatValidityPeriodDateEnd = (date) => {
        setInspectionSertificatValidityPeriodDateEnd(date);
    };
    const handleInpectOrderAttachmentDate = (date) => {
        setInpectOrderAttachmentDate(date);
    };
    const handleInpectOrderAttachmentDateEnd = (date) => {
        setInpectOrderAttachmentDateEnd(date);
    };
    const handleInspectionDocumentCheckDate = (date) => {
        setInspectionDocumentCheckDate(date);
    };
    const handleInspectionDocumentCheckDateEnd = (date) => {
        setInspectionDocumentCheckDateEnd(date);
    };
    const handleInspectCertificateCreateDate = (date) => {
        setInspectCertificateCreateDate(date);
    };
    const handleInspectCertificateCreateDateEnd = (date) => {
        setInspectCertificateCreateDateEnd(date);
    };
    const handleInspectionCertificateSertificatValidityPeriodDate = (date) => {
        setInspectionCertificateSertificatValidityPeriodDate(date);
    };
    const handleInspectionCertificateSertificatValidityPeriodDateEnd = (date) => {
        setInspectionCertificateSertificatValidityPeriodDateEnd(date);
    };
    const handleSertificatReleaseDate = (date) => {
        setSertificatReleaseDate(date);
    };
    const handleSertificatReleaseDateEnd = (date) => {
        setSertificatReleaseDateEnd(date);
    };

    const handleCreateDateEndChange = (date) => {
        setCreateDateFilterEnd(date);
    };

    const handleDeadlineChange = (date) => {
        setDeadlineFilter(date);
    };
    const handleDeadlineEndChange = (date) => {
        setDeadlineFilterEnd(date);
    };


    return (
        <div className={"table-container"}>
            {showAlertForRewrite && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlertForRewrite(false)}
                />
            )}
            {users.length !== 0 &&
                <CaseFilesDialog open={dialogOpen} onClose={handleCloseDialog} caseId={selectedId} users={users}
                                 showOnlyInspectFiles={showMainFilesOnDocumentPopup}
                                 showOnlyMainFiles={showOnlyMainFiles}/>
            }
            <ExcelPopup isVisible={loadingExport}/>
            <Snackbar
                open={alertInfo.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                sx={{top: {xs: '1%', sm: '1%'}}}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={alertInfo.severity}
                    sx={{width: '100%', fontSize: '1.25rem'}}
                >
                    {alertInfo.message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={showAlert}
                autoHideDuration={6000}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                TransitionComponent={Slide}
                sx={{
                    top: {xs: '1%', sm: '1%'},
                    '& .MuiAlert-root': {
                        fontSize: {xs: '1rem', sm: '1.25rem'},
                        fontFamily: "FiraGO-SemiBold",
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.1)'
                    }
                }}
            >
                <Alert
                    severity={alertInfo.severity}
                    sx={{width: '100%'}}
                >
                    {`განაცხადი ${alertText ? `ნომრით: ${alertText}` : ''} წარმატებით აიტვირთა!`}
                </Alert>
            </Snackbar>


            <div className="table-container-answers">
                {loading ? (
                        <div className="nothing-found-message-object-registery">
                            <HiDocumentSearch style={{fontSize: 80, color: '#1A9AEE'}} className={"pulse-element"}/>
                            <h1>გთხოვთ დაელოდოთ...</h1>
                            <p>განაცხადები იძებნება!</p>
                        </div>

                    ) :
                    (<div>
                            <button className="expand-button" onClick={toggleFullscreen}>
                                <FaExpand/>
                            </button>

                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                <div className="table-type">{tableTypes[tableViewOptions]}</div>
                            )}


                            {userRole !== null && userRole !== "USER" ? (
                                <div className="filter-container">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="ყველა ველით ძიება..."
                                                variant="outlined"
                                                fullWidth
                                                value={globalFieldFilter}
                                                onChange={handleGlobalFieldChange}
                                            />
                                        </Grid>
                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-label">ცხრილის ტიპი</InputLabel>
                                                    <Select
                                                        labelId="select-label"
                                                        value={tableViewOptions}
                                                        onChange={handleChangeTableOptions}
                                                        label="ცხრილის ტიპი"
                                                    >
                                                        <MenuItem value={1}>ძირითადი ცხრილი</MenuItem>
                                                        <MenuItem value={2}>სპეციალისტის ცხრილი</MenuItem>
                                                        <MenuItem value={3}>გარე მომხმარებლების ცხრილი</MenuItem>
                                                        <MenuItem value={4}>განაცხადის ცხრილი</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-label">ობიექტის სტატუსი</InputLabel>
                                                    <Select
                                                        labelId="select-label"
                                                        value={createByExpertValue}
                                                        onChange={handleChange}
                                                        label="ობიექტის სტატუსი"
                                                    >
                                                        <MenuItem value={1}>ყველა ობიექტი</MenuItem>
                                                        <MenuItem value={2}>რეგისტრირებული ობიექტები</MenuItem>
                                                        <MenuItem value={3}>არარეგისტრირებული
                                                            ობიექტები</MenuItem>
                                                        <MenuItem value={4}>აქტიური ობიექტები</MenuItem>
                                                        <MenuItem value={5}>არააქტიური ობიექტები</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {userRole && userRole !== "USER" && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>დაჩქარებული განაცხადები</InputLabel>
                                                    <Select
                                                        labelId="select-label"
                                                        value={requestedSpeedUpFilter}
                                                        onChange={handleRequestSpeedUp}
                                                        label="დაჩქარებული განაცხადები"
                                                    >
                                                        <MenuItem value={null}>ყველა განაცხადი</MenuItem>
                                                        <MenuItem value={"true"}>კი</MenuItem>
                                                        <MenuItem value={"false"}>არა</MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="განაცხადის ნომერი"
                                                variant="outlined"
                                                fullWidth
                                                value={caseNumberFilter}
                                                onChange={handleCaseNumberChange}
                                            />
                                        </Grid>
                                        {isObjectRegistery && (
                                            <>

                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="უწყებრივ რეესტრში რეგისტრაციის ნომერი"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={objectRegistryIdFilter}
                                                        onChange={handleObjectRegistryIdFilter}
                                                    />
                                                </Grid>
                                            </>
                                        )}

                                        <Grid item xs={12} sm={6} md={4}>
                                            <DatePicker
                                                selected={createDateFilter}
                                                onChange={handleCreateDateChange}
                                                customInput={
                                                    <TextField
                                                        label="ატვირთვის თარიღიდან"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                }
                                                autoComplete="off"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                scrollableYearDropdown
                                                dateFormat="dd/MM/yyyy"
                                                locale={ka}
                                                popperProps={{
                                                    positionFixed: true
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <DatePicker
                                                className="datepicker-search"
                                                selected={createDateFilterEnd}
                                                onChange={handleCreateDateEndChange}
                                                customInput={<TextField label="ატვირთვის თარიღამდე"
                                                                        variant="outlined"/>}
                                                autoComplete="off"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                scrollableYearDropdown
                                                dateFormat="dd/MM/yyyy"
                                                locale={ka}
                                                popperProps={{
                                                    positionFixed: true
                                                }}
                                            />
                                        </Grid>

                                        {location.pathname !== "/dashboard/objectregistrationtable" && (
                                            <>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <DatePicker
                                                        customInput={<TextField label="დასრულების თარიღიდან"
                                                                                variant="outlined"/>}
                                                        className="datepicker-search"
                                                        autoComplete="off"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        scrollableYearDropdown
                                                        selected={deadlineFilter}
                                                        onChange={handleDeadlineChange}
                                                        dateFormat="dd/MM/yyyy"
                                                        locale={ka}
                                                        popperProps={{
                                                            positionFixed: true
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <DatePicker
                                                        customInput={<TextField label="დასრულების თარიღამდე"
                                                                                variant="outlined"/>}
                                                        className="datepicker-search"
                                                        autoComplete="off"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        scrollableYearDropdown
                                                        selected={deadlineFilterEnd}
                                                        onChange={handleDeadlineEndChange}
                                                        dateFormat="dd/MM/yyyy"
                                                        locale={ka}
                                                        popperProps={{
                                                            positionFixed: true
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        )}

                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry" || location.pathname === "/dashboard/objectregistrationtable") ? (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>ობიექტი</InputLabel>
                                                    <Select
                                                        value={selectedPermitTypeId || ''}
                                                        label="ობიექტი"
                                                        onChange={handlePermitTypeChangeRegistery}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>ყველა ობიექტი</em>
                                                        </MenuItem>
                                                        {lastChildren.map(({id, title}) => (
                                                            <MenuItem key={id} value={id}>
                                                                {title}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>ობიექტი</InputLabel>
                                                    <Select
                                                        value={selectedPermitTypeId || ''}
                                                        label="ობიექტი"
                                                        onChange={(e) => handlePermitTypeChange(e.target.value)}
                                                        MenuProps={{
                                                            MenuListProps: {
                                                                disablePadding: true,
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            ყველა ობიექტი
                                                        </MenuItem>
                                                        {parentList.map((parent) => [
                                                            <MenuItem
                                                                key={parent.id}
                                                                value=""
                                                                disabled
                                                                style={{
                                                                    opacity: 1,
                                                                    fontWeight: 'bold',
                                                                    pointerEvents: 'none',
                                                                    backgroundColor: '#f0f0f0'
                                                                }}
                                                            >
                                                                {parent.description}
                                                            </MenuItem>,
                                                            ...permitTypeIdList
                                                                .filter(item => item.parentId === parent.id)
                                                                .map(item => (
                                                                    <MenuItem
                                                                        key={item.id}
                                                                        value={item.id}
                                                                    >
                                                                        {item.description}
                                                                    </MenuItem>
                                                                ))
                                                        ])}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}

                                        {isObjectRegistery && (
                                            <>
                                                {inputTypes.filter(inputType => inputType.title === "ობიექტის მფლობელის დასახელება").map((inputType) => (
                                                    <Grid item xs={12} sm={6} md={4} key={inputType.id}>
                                                        <TextField
                                                            label={inputType.title}
                                                            variant="outlined"
                                                            fullWidth
                                                            value={filterValues[inputType.title] || ''}
                                                            onChange={(e) => handleInputChange(e, inputType.title)}

                                                        />
                                                    </Grid>
                                                ))}</>
                                        )}

                                        {(location.pathname !== "/dashboard/newcases" && location.pathname !== "/dashboard/activecases") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <TextField
                                                    label="განმცხადებელი"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={requesterIdFilter}
                                                    onChange={(e) => setRequesterIdFilter(e.target.value)}
                                                />
                                            </Grid>
                                        )}
                                        {isAgencyAnswers && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <TextField
                                                    label="საკადასტრო კოდი"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={cadastralFilterForAnswers}
                                                    onChange={handleCadastralCodeChange}
                                                />
                                            </Grid>
                                        )}

                                        {isGeoDataInGeoArray("region") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>რეგიონი</InputLabel>
                                                    <Select
                                                        multiple
                                                        value={regionFilter}
                                                        label="რეგიონი"
                                                        onChange={handleRegionChange}
                                                        renderValue={(selected) => selected.map((id) => regions.find(region => region.id === id)?.itemName).join(', ')}
                                                    >
                                                        {regions.map((region) => (
                                                            <MenuItem key={region.id} value={region.id}>
                                                                {region.itemName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}

                                        {isGeoDataInGeoArray("municipality") && (
                                            <Tooltip title={regionFilter.length === 0 ? "ჯერ აირჩიეთ რეგიონი" : ""}>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControl fullWidth disabled={regionFilter.length === 0}>
                                                        <InputLabel>მუნიციპალიტეტი</InputLabel>
                                                        <Select
                                                            multiple
                                                            value={cityFilter}
                                                            label="მუნიციპალიტეტი"
                                                            onChange={handleCityChange}
                                                            renderValue={(selected) => selected.map((id) => cities.find(region => region.id === id)?.typesName).join(', ')}

                                                        >
                                                            {cities.map((city) => (
                                                                <MenuItem key={city.id} value={city.id}>
                                                                    {city.typesName}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Tooltip>
                                        )}
                                        {isGeoDataInGeoArray("council") &&
                                            (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") &&
                                            (
                                                <Tooltip
                                                    title={cityFilter.length === 0 ? "ჯერ აირჩიეთ მუნიციპალიტეტი" : ""}>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl fullWidth disabled={cityFilter.length === 0}>
                                                            <InputLabel>საკრებულო</InputLabel>
                                                            <Select
                                                                multiple
                                                                value={councilFilter}
                                                                label="საკრებულო"
                                                                onChange={handleCouncilChange}
                                                                renderValue={(selected) => selected.map((id) => councils.find(council => council.id === id)?.typesName).join(', ')}
                                                            >
                                                                {councils.map((council) => (
                                                                    <MenuItem key={council.id} value={council.id}>
                                                                        {council.typesName}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Tooltip>
                                            )}
                                        {isGeoDataInGeoArray("populated_area") && (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") && (
                                            <Tooltip title={councilFilter.length === 0 ? "ჯერ აირჩიეთ საკრებულო" : ""}>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControl
                                                        style={{cursor: councilFilter.length === 0 ? "not-allowed" : "pointer"}}
                                                        fullWidth disabled={councilFilter.length === 0}>
                                                        <InputLabel>დასახლებული პუნქტი</InputLabel>
                                                        <Select
                                                            multiple
                                                            value={populatedAreaFilter}
                                                            label="დასახლებული პუნქტი"
                                                            onChange={handlePopulatedAreaChange}
                                                            renderValue={(selected) => selected.map((id) => populatedAreas.find(popArea => popArea.id === id)?.typesName).join(', ')}
                                                        >
                                                            {populatedAreas.map((city) => (
                                                                <MenuItem key={city.id} value={city.id}>
                                                                    {city.typesName}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Tooltip>
                                        )}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="მოთხოვნა"
                                                variant="outlined"
                                                fullWidth
                                                value={requestFilter}
                                                onChange={handleRequestFilter}
                                            />
                                        </Grid>
                                        {location.pathname !== "/dashboard/declinedcases" && location.pathname !== "/dashboard/finishedcases" && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>სტატუსი</InputLabel>
                                                    <Select
                                                        label="სტატუსი"
                                                        multiple
                                                        value={statusFilter}
                                                        onChange={handleStatusChange}
                                                    >
                                                        {Object.values(CaseStatusForUserDropDown).map((status) => (
                                                            <MenuItem key={status.id} value={status.id}>
                                                                {status.title}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}


                                        {userRole !== "USER" && userRole && users.length !== 0 && (location.pathname !== "/agencyanswers" && location.pathname !== "/dashboard/agencyanswers" && location.pathname !== "/dashboard/objectregistrationtable" && location.pathname !== "/dashboard/lastusercases") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Autocomplete
                                                    value={users.find(user => user.id === userFilter) || null}
                                                    onChange={handleUserChange}
                                                    options={users}
                                                    getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${rolesInGeorgian[option.roleName]})`}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="შემსრულებელი"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                    noOptionsText="არაფერი მოიძებნა!"
                                                    fullWidth
                                                />
                                            </Grid>
                                        )}
                                        {(userRole && (userRole === "DEPUTYHEADOFAGENCY" || userRole === "HEADOFAGENCY")) && (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-label">სამმართველო</InputLabel>
                                                    <Select
                                                        labelId="select-label"
                                                        value={selectedDepartmentId}
                                                        onChange={handleChangeDepartment}
                                                        label="სამმართველო"
                                                    >
                                                        <MenuItem value={null}>ყველა სამმართველო</MenuItem>
                                                        <MenuItem value={1}>მშენებლობის ნებართვა</MenuItem>
                                                        <MenuItem value={2}>სამრეწველო დანიშნულების ფეთქებადი
                                                            მასალები</MenuItem>
                                                        <MenuItem value={3}>მომეტებული საფრთხის შემცვლელი
                                                            ობიექტები</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}


                                        {isTableExpanded && (
                                            <>


                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="multiple-select-label">მისამართის
                                                            ველები</InputLabel>
                                                        <Select
                                                            labelId="multiple-select-label"
                                                            multiple
                                                            label="მისამართის ველები"
                                                            value={selectedGeoData}
                                                            onChange={handleChangeGeoData}
                                                            renderValue={(selected) => selected.map(value =>
                                                                geoTitles.find(item => item.value === value)?.label).join(', ')}
                                                        >
                                                            {geoTitles.map(department => (
                                                                <MenuItem key={department.value}
                                                                          value={department.value}>
                                                                    <Checkbox
                                                                        checked={selectedGeoData.includes(department.value)}/>
                                                                    <ListItemText primary={department.label}/>
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <TextField
                                                            label="შენიშვნა"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={noteFilter}
                                                            onChange={handleNoteChange}
                                                        />
                                                    </Grid>
                                                )}


                                                {userRole && userRole !== "USER" && users.length !== 0 && (location.pathname !== "/agencyanswers" && location.pathname !== "/dashboard/agencyanswers" && location.pathname !== "/dashboard/objectregistrationtable") && (
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl fullWidth>
                                                            <InputLabel>პოზიცია</InputLabel>
                                                            <Select
                                                                label="პოზიცია"
                                                                value={roleFilter}
                                                                onChange={handleRoleChange}
                                                            >
                                                                {Object.keys(rolesInGeorgian).map((roleKey) => (
                                                                    <MenuItem key={roleKey} value={roleKey}>
                                                                        {rolesInGeorgian[roleKey]}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                )}
                                                {inputTypes.filter(inputType => inputType.title !== "ობიექტის მფლობელის დასახელება").map((inputType) => (
                                                    <Grid item xs={12} sm={6} md={4} key={inputType.id}>
                                                        <TextField
                                                            label={inputType.title}
                                                            variant="outlined"
                                                            fullWidth
                                                            value={filterValues[inputType.title] || ''}
                                                            onChange={(e) => handleInputChange(e, inputType.title)}

                                                        />
                                                    </Grid>
                                                ))}
                                            </>
                                        )}

                                        {isInspectDialogOpen && (
                                            <>
                                                <div className="inspect-dialog-overlay" onClick={closeInspectDialog}>


                                                    <div className="inspect-dialog-content"
                                                         onClick={e => e.stopPropagation()}>
                                                        <IoIosCloseCircle
                                                            className="filter-close-icon"
                                                            onClick={closeInspectDialog}
                                                        />
                                                        <div className={"search-dialog-title"}>ინსპექტირების ოქმი:</div>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField
                                                                    label="ინსპექტირების ოქმის სახელი"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={caseFileInspectFileFileFilters}
                                                                    onChange={handleCaseFileInspectFileFileFilters}
                                                                    InputProps={{
                                                                        endAdornment: caseFileInspectFileFileFilters ? (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => handleCaseFileInspectFileFileFilters({target: {value: ""}})}
                                                                                    edge="end"
                                                                                >
                                                                                    <MdClose/>
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ) : null,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField
                                                                    label="კრიტიკული შეუსაბამომებები"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={inconsistenciesCritical}
                                                                    onChange={(e) => handleInconsistenciesCritical(e)}
                                                                    inputProps={{min: 0, max: 1000000}}
                                                                    type="number"
                                                                    InputProps={{
                                                                        endAdornment: inconsistenciesCritical ? (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => handleInconsistenciesCritical({target: {value: ""}})}
                                                                                    edge="end"
                                                                                >
                                                                                    <MdClose/>
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ) : null,
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField
                                                                    label="არსებითი შეუსაბამომებები"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={inconsistenciesNonSubstantial}
                                                                    onChange={(e) => handleInconsistenciesNonSubstantial(e)}
                                                                    inputProps={{min: 0, max: 1000000}}
                                                                    type="number"
                                                                    InputProps={{
                                                                        endAdornment: inconsistenciesNonSubstantial ? (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => handleInconsistenciesNonSubstantial({target: {value: ""}})}
                                                                                    edge="end"
                                                                                >
                                                                                    <MdClose/>
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ) : null,
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField
                                                                    label="არაარსებითი შეუსაბამომებები"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={inconsistenciesSubstantial}
                                                                    onChange={(e) => handleInconsistenciesSubstantial(e)}
                                                                    inputProps={{min: 0, max: 1000000}}
                                                                    type="number"
                                                                    InputProps={{
                                                                        endAdornment: inconsistenciesSubstantial ? (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => handleInconsistenciesSubstantial({target: {value: ""}})}
                                                                                    edge="end"
                                                                                >
                                                                                    <MdClose/>
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ) : null,
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel>ინსპექტირების ჩაუტარებლობა
                                                                        დარღვევა</InputLabel>
                                                                    <Select
                                                                        value={violationFailureToConductInspection}
                                                                        onChange={handleViolationFailureToConductInspection}
                                                                        input={
                                                                            <OutlinedInput
                                                                                label="ინსპექტირების ჩაუტარებლობა დარღვევა"
                                                                                endAdornment={violationFailureToConductInspection !== null ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => handleViolationFailureToConductInspection({target: {value: null}})}
                                                                                            edge="end"
                                                                                            style={{marginRight: '8px'}}  // Adds margin to the right of the icon
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null}
                                                                            />

                                                                        }
                                                                    >
                                                                        <MenuItem value={null}>ინსპექტირების
                                                                            ჩაუტარებლობა დარღვევა</MenuItem>
                                                                        <MenuItem value={1}>კი</MenuItem>
                                                                        <MenuItem value={0}>არა</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel>ფარული ექსპლუატაცია
                                                                        დარღვევა</InputLabel>
                                                                    <Select
                                                                        label="ფარული ექსპლუატაცია დარღვევა"
                                                                        value={violationHiddenExploitation}
                                                                        onChange={handleViolationHiddenExploitation}
                                                                        input={
                                                                            <OutlinedInput
                                                                                label="ფარული ექსპლუატაცია დარღვევა"
                                                                                endAdornment={violationHiddenExploitation ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => handleViolationHiddenExploitation({target: {value: ''}})}
                                                                                            edge="end"
                                                                                            style={{marginRight: '8px'}}
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null}
                                                                            />

                                                                        }
                                                                    >

                                                                        <MenuItem value={null}>ფარული ექსპლუატაცია
                                                                            დარღვევა</MenuItem>
                                                                        <MenuItem value={1}>კი</MenuItem>
                                                                        <MenuItem value={0}>არა</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                            {users.length !== 0 && (
                                                                <Grid item xs={12} sm={6} md={4}>
                                                                    <Autocomplete
                                                                        value={users.find(user => user.id === inspectFileCreatorID) || null}
                                                                        onChange={handleInspectUserChange}
                                                                        options={users}
                                                                        getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${rolesInGeorgian[option.roleName]})`}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label="ინსპექტირების დოკუმენტის ატვირთა"
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                        noOptionsText="არაფერი მოიძებნა!"
                                                                        fullWidth
                                                                    />
                                                                </Grid>
                                                            )}
                                                            {users.length !== 0 && (
                                                                <Grid item xs={12} sm={6} md={4}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel>ინსპექტორები</InputLabel>
                                                                        <Select
                                                                            multiple
                                                                            value={inspectors}
                                                                            label="ინსპექტორები"
                                                                            input={
                                                                                <OutlinedInput
                                                                                    label="ინსპექტორები"
                                                                                    endAdornment={inspectors.length !== 0 ? (
                                                                                        <InputAdornment position="end">
                                                                                            <IconButton
                                                                                                onClick={() => handleInspectorsChange({target: {value: []}})}
                                                                                                edge="end"
                                                                                                style={{marginRight: '8px'}}
                                                                                            >
                                                                                                <MdClose/>
                                                                                            </IconButton>
                                                                                        </InputAdornment>
                                                                                    ) : null}
                                                                                />

                                                                            }
                                                                            onChange={handleInspectorsChange}
                                                                            renderValue={(selected) => selected.map((id) => users.find(users => users.id === id)?.firstName + " " + users.find(users => users.id === id)?.lastName).join(', ')}
                                                                        >
                                                                            {users.map((user) => (
                                                                                <MenuItem key={user.id} value={user.id}>
                                                                                    {`${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                            )}

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={inspectionDocumentCreateAt}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleInspectionCreatedAt(start);
                                                                        handleInspectionCreatedAtEnd(end);
                                                                    }}
                                                                    startDate={inspectionDocumentCreateAt}
                                                                    endDate={inspectionDocumentCreateAtEnd}
                                                                    selectsRange
                                                                    monthsShown={2} // This shows two months side by side
                                                                    customInput={
                                                                        <TextField
                                                                            label="ინსპექტირების ოქმის ატვირთვის თარიღი"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                inspectionDocumentCreateAt && inspectionDocumentCreateAtEnd
                                                                                    ? `${inspectionDocumentCreateAt?.toLocaleDateString('ka-GE')} - ${inspectionDocumentCreateAtEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: inspectionDocumentCreateAt || inspectionDocumentCreateAtEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleInspectionCreatedAt(null);
                                                                                                handleInspectionCreatedAtEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={inspectionSertificatValidityPeriodDate}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleInspectionSertificatValidityPeriodDate(start);
                                                                        handleInspectionSertificatValidityPeriodDateEnd(end);
                                                                    }}
                                                                    startDate={inspectionSertificatValidityPeriodDate}
                                                                    endDate={inspectionSertificatValidityPeriodDateEnd}
                                                                    selectsRange
                                                                    monthsShown={2} // This shows two months side by side
                                                                    customInput={
                                                                        <TextField
                                                                            label="განხორციელების თარიღი"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                inspectionSertificatValidityPeriodDate && inspectionSertificatValidityPeriodDateEnd
                                                                                    ? `${inspectionSertificatValidityPeriodDate?.toLocaleDateString('ka-GE')} - ${inspectionSertificatValidityPeriodDateEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: inspectionSertificatValidityPeriodDate || inspectionSertificatValidityPeriodDateEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleInspectionSertificatValidityPeriodDate(null);
                                                                                                handleInspectionSertificatValidityPeriodDateEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={inpectOrderAttachmentDate}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleInpectOrderAttachmentDate(start);
                                                                        handleInpectOrderAttachmentDateEnd(end);
                                                                    }}
                                                                    startDate={inpectOrderAttachmentDate}
                                                                    endDate={inpectOrderAttachmentDateEnd}
                                                                    selectsRange
                                                                    monthsShown={2}
                                                                    customInput={
                                                                        <TextField
                                                                            label="შედგენის თარიღი"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                inpectOrderAttachmentDate && inpectOrderAttachmentDateEnd
                                                                                    ? `${inpectOrderAttachmentDate?.toLocaleDateString('ka-GE')} - ${inpectOrderAttachmentDateEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: inpectOrderAttachmentDate || inpectOrderAttachmentDateEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleInpectOrderAttachmentDate(null);
                                                                                                handleInpectOrderAttachmentDateEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={inspectionDocumentCheckDate}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleInspectionDocumentCheckDate(start);
                                                                        handleInspectionDocumentCheckDateEnd(end);
                                                                    }}
                                                                    startDate={inspectionDocumentCheckDate}
                                                                    endDate={inspectionDocumentCheckDateEnd}
                                                                    selectsRange
                                                                    monthsShown={2}
                                                                    customInput={
                                                                        <TextField
                                                                            label="გადამოწმების თარიღი"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                inspectionDocumentCheckDate && inspectionDocumentCheckDateEnd
                                                                                    ? `${inspectionDocumentCheckDate?.toLocaleDateString('ka-GE')} - ${inspectionDocumentCheckDateEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: inspectionDocumentCheckDate || inspectionDocumentCheckDateEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleInspectionDocumentCheckDate(null);
                                                                                                handleInspectionDocumentCheckDateEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>
                                                            <div style={{marginLeft: 20, marginTop: 5}}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={inconsistenciesCriticalFilter}
                                                                            onChange={(e) => setInconsistenciesCriticalFilter(e.target.checked)}
                                                                        />
                                                                    }
                                                                    label="კრიტიკული შეუსაბამომებები"
                                                                />
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={inconsistenciesNonSubstantialFilter}
                                                                            onChange={(e) => setInconsistenciesNonSubstantialFilter(e.target.checked)}
                                                                        />
                                                                    }
                                                                    label="არაარსებითი შეუსაბამომებები"
                                                                />
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={inconsistenciesSubstantialFilter}
                                                                            onChange={(e) => setInconsistenciesSubstantialFilter(e.target.checked)}
                                                                        />
                                                                    }
                                                                    label="არსებითი შეუსაბამომებები"
                                                                />
                                                            </div>
                                                        </Grid>
                                                        <div className={"search-dialog-title"}>
                                                            ინსპექტირების სერტიფიკატი:
                                                        </div>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField
                                                                    label="ინსპექტირების სერთიფიკატის სახელი"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={inspectCertificate}
                                                                    onChange={handleInspectCertificate}
                                                                    InputProps={{
                                                                        endAdornment: inspectCertificate ? (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => handleInspectCertificate({target: {value: ""}})}
                                                                                    edge="end"
                                                                                >
                                                                                    <MdClose/>
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ) : null,
                                                                    }}
                                                                />
                                                            </Grid>


                                                            {users.length !== 0 && (
                                                                <Grid item xs={12} sm={6} md={4}>
                                                                    <Autocomplete
                                                                        value={users.find(user => user.id === inspectFileCertificateCreatorID) || null}
                                                                        onChange={handleInspectCertificateUserChange}
                                                                        options={users}
                                                                        getOptionLabel={(option) => `${option.firstName} ${option.lastName} (${rolesInGeorgian[option.roleName]})`}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label="ინსპექტირების სერთიფიკატი ატვირთა"
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                        noOptionsText="არაფერი მოიძებნა!"
                                                                        fullWidth
                                                                    />
                                                                </Grid>
                                                            )}

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <TextField
                                                                    label="გამცემი ორგანო"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={inspectionSertificatIssuingAgency}
                                                                    onChange={handleInspectionSertificatIssuingAgency}
                                                                    InputProps={{
                                                                        endAdornment: inspectionSertificatIssuingAgency ? (
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => handleInspectionSertificatIssuingAgency({target: {value: ""}})}
                                                                                    edge="end"
                                                                                >
                                                                                    <MdClose/>
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ) : null,
                                                                    }}

                                                                />
                                                            </Grid>


                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={inspectCertificateCreateDate}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleInspectCertificateCreateDate(start);
                                                                        handleInspectCertificateCreateDateEnd(end);
                                                                    }}
                                                                    startDate={inspectCertificateCreateDate}
                                                                    endDate={inspectCertificateCreateDateEnd}
                                                                    selectsRange
                                                                    monthsShown={2}
                                                                    customInput={
                                                                        <TextField
                                                                            label="ინსპექტირების სერთიფიკატის ატვირთვის თარიღი"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                inspectCertificateCreateDate && inspectCertificateCreateDateEnd
                                                                                    ? `${inspectCertificateCreateDate?.toLocaleDateString('ka-GE')} - ${inspectCertificateCreateDateEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: inspectCertificateCreateDate || inspectCertificateCreateDateEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleInspectCertificateCreateDate(null);
                                                                                                handleInspectCertificateCreateDateEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={inspectionCertificateSertificatValidityPeriodDate}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleInspectionCertificateSertificatValidityPeriodDate(start);
                                                                        handleInspectionCertificateSertificatValidityPeriodDateEnd(end);
                                                                    }}
                                                                    startDate={inspectionCertificateSertificatValidityPeriodDate}
                                                                    endDate={inspectionCertificateSertificatValidityPeriodDatEnd}
                                                                    selectsRange
                                                                    monthsShown={2} // This shows two months side by side
                                                                    customInput={
                                                                        <TextField
                                                                            label="მოქმედების ვადა"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                inspectionCertificateSertificatValidityPeriodDate && inspectionCertificateSertificatValidityPeriodDatEnd
                                                                                    ? `${inspectionCertificateSertificatValidityPeriodDate?.toLocaleDateString('ka-GE')} - ${inspectionCertificateSertificatValidityPeriodDatEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: inspectionCertificateSertificatValidityPeriodDate || inspectionCertificateSertificatValidityPeriodDatEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleInspectionCertificateSertificatValidityPeriodDate(null);
                                                                                                handleInspectionCertificateSertificatValidityPeriodDateEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <DatePicker
                                                                    className="datepicker-search-dialogue"
                                                                    selected={sertificatReleaseDate}
                                                                    onChange={(dates) => {
                                                                        const [start, end] = dates;
                                                                        handleSertificatReleaseDate(start);
                                                                        handleSertificatReleaseDateEnd(end);
                                                                    }}
                                                                    startDate={sertificatReleaseDate}
                                                                    endDate={sertificatReleaseDateEnd}
                                                                    selectsRange
                                                                    monthsShown={2} // This shows two months side by side
                                                                    customInput={
                                                                        <TextField
                                                                            label="გაცემის თარიღი"
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            value={
                                                                                sertificatReleaseDate && sertificatReleaseDateEnd
                                                                                    ? `${sertificatReleaseDate?.toLocaleDateString('ka-GE')} - ${sertificatReleaseDateEnd?.toLocaleDateString('ka-GE')}`
                                                                                    : ''
                                                                            }
                                                                            InputProps={{
                                                                                endAdornment: sertificatReleaseDate || sertificatReleaseDateEnd ? (
                                                                                    <InputAdornment position="end">
                                                                                        <IconButton
                                                                                            onClick={() => {
                                                                                                handleSertificatReleaseDate(null);
                                                                                                handleSertificatReleaseDateEnd(null);
                                                                                            }}
                                                                                            edge="end"
                                                                                        >
                                                                                            <MdClose/>
                                                                                        </IconButton>
                                                                                    </InputAdornment>
                                                                                ) : null,
                                                                            }}
                                                                        />
                                                                    }
                                                                    autoComplete="off"
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    dateFormat="dd/MM/yyyy"
                                                                    locale={ka}
                                                                />
                                                            </Grid>


                                                        </Grid>

                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginTop: 30
                                                        }}>
                                                            <Button
                                                                ref={buttonRef}
                                                                onClick={() => {
                                                                    saveFiltersToLocalStorage();
                                                                    void fetchDataTable();
                                                                    setPage(0);
                                                                    navigate(`${location.pathname}?page=0`);
                                                                }}

                                                                variant="contained"
                                                                color="primary"
                                                                endIcon={<AiOutlineSearch/>}
                                                                disabled={loadingNames}
                                                                fullWidth
                                                            >
                                                                ძიება
                                                            </Button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <Grid item xs={12} style={{display: "flex", gap: 5}}>
                                            <Button
                                                ref={buttonRef}
                                                onClick={() => {
                                                    saveFiltersToLocalStorage();
                                                    void fetchDataTable();
                                                    setPage(0);
                                                    navigate(`${location.pathname}?page=0`);
                                                }}
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                endIcon={<AiOutlineSearch/>}
                                                disabled={loadingNames}
                                            >
                                                ძიება
                                            </Button>


                                            <Button
                                                onClick={() => {
                                                    clearFilters();
                                                    setPage(0);
                                                    navigate(`${location.pathname}?page=0`);
                                                }}
                                                variant="contained"
                                                color="error"
                                                fullWidth
                                                endIcon={<MdOutlineCleaningServices/>}
                                            >
                                                ფილტრების წაშლა
                                            </Button>
                                            {userRole !== "USER" && userRole !== "ROOTADMIN" && userRole && (
                                                <Tooltip
                                                    title={isExcelButtonDisabled ? "ექსელში ექპორტისტის აირჩიეთ ველები!" : ""}>
                                                    <div style={{
                                                        cursor: !isExcelButtonDisabled ? "pointer" : "not-allowed",
                                                        width: "100%"
                                                    }}>
                                                        <Button
                                                            onClick={handleExportToExcel}
                                                            variant="contained"
                                                            disabled={isExcelButtonDisabled}
                                                            style={{
                                                                backgroundColor: !isExcelButtonDisabled ? "green" : "gray",
                                                            }}
                                                            fullWidth
                                                            endIcon={<FaFileExcel/>}
                                                        >
                                                            ექსელში ექპორტი
                                                        </Button>
                                                    </div>
                                                </Tooltip>
                                            )}
                                        </Grid>
                                        <div className={"register-count-container"}>
                                            <div className="record-count-box-registery-map">
                                                ნაპოვნია {totalRecords || 0} ჩანაწერი
                                            </div>


                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                <div>
                                                    <button className="additional-filters-button"
                                                            onClick={openInspectDialog}>
                                                        <FaFilter/>
                                                        დამატებითი ფილტრები
                                                    </button>

                                                </div>
                                            )}
                                            {userRole &&
                                                userRole !== "USER" &&
                                                userRole !== "ROOTADMIN" &&
                                                !(location.pathname === "/dashboard/registery" ||
                                                    location.pathname === "/objectregistry") &&
                                                (
                                                    <div style={{paddingTop: 30}}>
                                                        <Checkbox
                                                            checked={isTableExpanded}
                                                            onChange={(e) => {
                                                                setIsTableExpanded(e.target.checked);
                                                            }}
                                                        />
                                                        <label>ყველა ფილტრის გამოჩენა</label>
                                                    </div>
                                                )}

                                            <div onClick={() => {
                                                const caseNumberList = data.map(item => item.caseNumber);
                                                const caseNumberListStr = caseNumberList.map(item => `'${item}'`).join(',');
                                                sessionStorage.setItem('caseNumberList', caseNumberListStr);
                                                navigate("/interactivemap")
                                            }
                                            } className={"record-count-box-registery-map"}>რუკაზე ნახვა
                                            </div>


                                            {userRole === "USER" && (location.pathname !== "/agencyanswers" && location.pathname !== "/objectregistry") && (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        navigate(`/services`);
                                                    }}
                                                    startIcon={<AiOutlinePlus/>}
                                                >
                                                    განაცხადის რეგისტრაცია
                                                </Button>
                                            )}
                                            {location.pathname === "/dashboard/objectregistrationtable" && userRole !== "USER" &&
                                                (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            navigate(`/dashboard/objectregistration`);
                                                        }}
                                                        startIcon={<AiOutlinePlus/>}
                                                    >
                                                        განაცხადის რეგისტრაცია
                                                    </Button>
                                                )

                                            }
                                        </div>
                                    </Grid>
                                    {users.length !== 0 && permitTypeIdList.length !== 0 && (
                                        <div>
                                            {renderFilterChips()}
                                        </div>
                                    )}

                                </div>
                            ) : (
                                <div className="filter-container">

                                    <Grid container spacing={2}>

                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry" || location.pathname === "/dashboard/objectregistrationtable") ? (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>მოთხოვნის ტიპი</InputLabel>
                                                    <Select
                                                        value={selectedPermitTypeId || ''}
                                                        label="მოთხოვნის ტიპი"
                                                        onChange={handlePermitTypeChangeRegistery}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>მოთხოვნის ტიპი</em>
                                                        </MenuItem>
                                                        {lastChildren.map(({id, title}) => (
                                                            <MenuItem key={id} value={id}>
                                                                {title}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>მოთხოვნის ტიპი</InputLabel>
                                                    <Select
                                                        value={selectedPermitTypeId || ''}
                                                        label="მოთხოვნის ტიპი"
                                                        onChange={(e) => handlePermitTypeChange(e.target.value)}
                                                        MenuProps={{
                                                            MenuListProps: {
                                                                disablePadding: true,
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            მოთხოვნის ტიპი
                                                        </MenuItem>
                                                        {parentList.map((parent) => [
                                                            <MenuItem
                                                                key={parent.id}
                                                                value=""
                                                                disabled
                                                                style={{
                                                                    opacity: 1,
                                                                    fontWeight: 'bold',
                                                                    pointerEvents: 'none',
                                                                    backgroundColor: '#f0f0f0'
                                                                }}
                                                            >
                                                                {parent.description}
                                                            </MenuItem>,
                                                            ...permitTypeIdList
                                                                .filter(item => item.parentId === parent.id)
                                                                .map(item => (
                                                                    <MenuItem
                                                                        key={item.id}
                                                                        value={item.id}
                                                                    >
                                                                        {item.description}
                                                                    </MenuItem>
                                                                ))
                                                        ])}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="განაცხადის ნომერი"
                                                variant="outlined"
                                                fullWidth
                                                value={caseNumberFilter}
                                                onChange={handleCaseNumberChange}
                                            />
                                        </Grid>


                                        {location.pathname !== "/dashboard/declinedcases" && !isObjectRegistery && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>სტატუსი</InputLabel>
                                                    <Select
                                                        label="სტატუსი"
                                                        multiple
                                                        value={statusFilter}
                                                        onChange={handleStatusChange}
                                                    >
                                                        {Object.values(CaseStatusForDropdown).map((status) => (
                                                            <MenuItem key={status.id} value={status.id}>
                                                                {status.title}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}

                                        {isObjectRegistery && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>სტატუსი</InputLabel>
                                                    <Select
                                                        label="სტატუსი"
                                                        multiple
                                                        value={statusFilter}
                                                        onChange={handleStatusChange}
                                                    >
                                                        {Object.values(CaseStatusesForObjectRegistery).map((status) => (
                                                            <MenuItem key={status.id} value={status.id}>
                                                                {status.title}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}


                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                            <Grid item xs={12} sm={6} md={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-label">ობიექტის სტატუსი</InputLabel>
                                                    <Select
                                                        labelId="select-label"
                                                        value={createByExpertValue}
                                                        onChange={handleChange}
                                                        label="ობიექტის სტატუსი"
                                                    >
                                                        <MenuItem value={1}>ყველა ობიექტი</MenuItem>
                                                        <MenuItem value={2}>რეგისტრირებული ობიექტები</MenuItem>
                                                        <MenuItem value={3}>არარეგისტრირებული ობიექტები</MenuItem>
                                                        <MenuItem value={4}>აქტიური ობიექტები</MenuItem>
                                                        <MenuItem value={5}>არააქტიური ობიექტები</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}

                                        <Grid item xs={12} sm={6} md={4}>
                                            <DatePicker
                                                className="datepicker-search"
                                                selected={createDateFilter}
                                                onChange={handleCreateDateChange}
                                                customInput={<TextField label="ატვირთვის  თარიღიდან"
                                                                        variant="outlined"/>}
                                                autoComplete="off"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                scrollableYearDropdown
                                                dateFormat="dd/MM/yyyy"
                                                locale={ka}
                                                popperProps={{
                                                    positionFixed: true
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <DatePicker
                                                className="datepicker-search"
                                                selected={createDateFilterEnd}
                                                onChange={handleCreateDateEndChange}
                                                customInput={<TextField label="ატვირთვის თარიღამდე"
                                                                        variant="outlined"/>}
                                                autoComplete="off"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                scrollableYearDropdown
                                                dateFormat="dd/MM/yyyy"
                                                locale={ka}
                                                popperProps={{
                                                    positionFixed: true
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} style={{display: "flex", gap: 5}}>
                                            <Button
                                                ref={buttonRef}
                                                onClick={() => {
                                                    saveFiltersToLocalStorage();
                                                    void fetchDataTable();
                                                    setPage(0);
                                                    navigate(`${location.pathname}?page=0`);
                                                }}
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                endIcon={<AiOutlineSearch/>}
                                                disabled={loadingNames}
                                            >
                                                ძიება
                                            </Button>

                                            <Button
                                                onClick={() => {
                                                    clearFilters();
                                                    setPage(0);
                                                }}
                                                variant="contained"
                                                color="error"
                                                fullWidth
                                                endIcon={<MdOutlineCleaningServices/>}
                                            >
                                                ფილტრების წაშლა
                                            </Button>
                                            {userRole !== "USER" && userRole && (
                                                <Tooltip
                                                    title={isExcelButtonDisabled ? "ექსელში ექპორტისტის აირჩიეთ ველები!" : ""}>
                                                    <div style={{
                                                        cursor: !isExcelButtonDisabled ? "pointer" : "not-allowed",
                                                        width: "100%"
                                                    }}>
                                                        <Button
                                                            onClick={handleExportToExcel}
                                                            variant="contained"
                                                            disabled={isExcelButtonDisabled}
                                                            style={{
                                                                backgroundColor: !isExcelButtonDisabled ? "green" : "gray",
                                                            }}
                                                            fullWidth
                                                            endIcon={<FaFileExcel/>}
                                                        >
                                                            ექსელში ექპორტი
                                                        </Button>
                                                    </div>
                                                </Tooltip>
                                            )}
                                        </Grid>
                                        <div className={"register-count-container"}>
                                            <div className="record-count-box-registery-map">
                                                ნაპოვნია {totalRecords || 0} ჩანაწერი
                                            </div>
                                            {selectedCases.length !== 0 && selectedCasesFullData.length !== 0 && (
                                                <RewriteRequest selectedCases={selectedCases}
                                                                selectedCasesFullData={selectedCasesFullData}
                                                                onRequest={unselectCases}/>
                                            )}

                                            <div onClick={() => {
                                                const caseNumberList = data.map(item => item.caseNumber);
                                                const caseNumberListStr = caseNumberList.map(item => `'${item}'`).join(',');
                                                sessionStorage.setItem('caseNumberList', caseNumberListStr);
                                                navigate("/interactivemap")
                                            }} className={"record-count-box-registery-map"}>რუკაზე ნახვა
                                            </div>


                                            {userRole === "USER" && (location.pathname !== "/agencyanswers" && location.pathname !== "/objectregistry") && (
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        navigate(`/services`);
                                                    }}
                                                    startIcon={<AiOutlinePlus/>}
                                                >
                                                    განაცხადის რეგისტრაცია
                                                </Button>
                                            )}
                                            {location.pathname === "/dashboard/objectregistrationtable" && userRole !== "USER" &&
                                                (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            navigate(`/dashboard/objectregistration`);
                                                        }}
                                                        startIcon={<AiOutlinePlus/>}
                                                    >
                                                        განაცხადის რეგისტრაცია
                                                    </Button>
                                                )

                                            }
                                        </div>
                                    </Grid>
                                    {users.length !== 0 && permitTypeIdList.length !== 0 && (
                                        <div>
                                            {renderFilterChips()}
                                        </div>
                                    )}

                                </div>
                            )}


                            {data.length === 0 ? (
                                <div className="nothing-found-message">
                                    <FontAwesomeIcon icon={faSearch} size="3x"/>
                                    <p>არაფერი მოიძებნა!</p>
                                </div>) : (
                                <div className={"table-container-resposivee"}>
                                    <table className="case-table">
                                        <thead>
                                        <tr>
                                            {userRole && userRole === "USER" && isAgencyAnswers && (
                                                <th
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }}
                                                    title={"განაცხადის არჩევა"}>
                                                    განაცხადის არჩევა
                                                </th>
                                            )}

                                            <th style={{
                                                textAlign: 'center',
                                                fontFamily: "'FiraGO-SemiBold'",
                                                fontSize: 14,
                                                cursor: "pointer"
                                            }} onClick={() => handleSortChange('id')} title={"განაცხადის №"}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>
                                                        განაცხადის №
                                                        {sortField === 'id' ? (sortOrder ?
                                                                <FaSortDown style={{marginLeft: 5}}/> :
                                                                <FaSortUp style={{marginLeft: 5}}/>) :
                                                            <FaSort style={{marginLeft: 5}}/>}
                                                    </span>
                                                    {userRole && userRole !== "USER" && (
                                                        <Checkbox
                                                            checked={checkedState["განაცხადის ნომერი"] || false}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            onChange={(e) => handleCheckboxChange("განაცხადის ნომერი", e.target.checked)}
                                                            color="primary"
                                                        />
                                                    )}
                                                </div>
                                            </th>

                                            {userRole === 'ROOTADMIN' && userRole && (location.pathname === "/dashboard/hidecases") && (
                                                <th
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }}
                                                    title={"განაცხადის წაშლა"}>
                                                    განაცხადის წაშლა

                                                </th>
                                            )}
                                            {userRole === 'ROOTADMIN' && userRole && (location.pathname === "/dashboard/hidecases") && (
                                                <th
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }}
                                                    title={"განაცხადის დამალვა"}>
                                                    განაცხადის დამალვა

                                                </th>
                                            )}

                                            <th style={{
                                                maxWidth: 10,
                                                textAlign: 'center',
                                                fontFamily: "'FiraGO-SemiBold'",
                                                fontSize: 14,
                                                cursor: "pointer"
                                            }} onClick={() => handleSortChange('CreateDate')}
                                                title={"რეგისტრაციის თარიღი"}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>

                                                        რეგისტრაციის თარიღი
                                                        {sortField === 'CreateDate' ? (sortOrder ?
                                                                <FaSortDown style={{marginLeft: 5}}/> :
                                                                <FaSortUp style={{marginLeft: 5}}/>) :
                                                            <FaSort style={{marginLeft: 5}}/>}
                                                    </span>

                                                    {userRole && userRole !== "USER" && (
                                                        <Checkbox
                                                            checked={checkedState["აიტვირთა"] || false}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            onChange={(e) => handleCheckboxChange("აიტვირთა", e.target.checked)}
                                                            color="primary"
                                                        />
                                                    )}

                                                </div>

                                            </th>
                                            <th style={{
                                                textAlign: 'center',
                                                fontFamily: "'FiraGO-SemiBold'",
                                                fontSize: 14,
                                                cursor: "pointer"
                                            }} onClick={() => handleSortChange('Dedline')}
                                                title={"სრულდება"}>

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>
                                                        სრულდება
                                                        {sortField === 'Dedline' ? (sortOrder ?
                                                                <FaSortDown style={{marginLeft: 5}}/> :
                                                                <FaSortUp style={{marginLeft: 5}}/>) :
                                                            <FaSort style={{marginLeft: 5}}/>}
                                                    </span>

                                                    {userRole && userRole !== "USER" && (
                                                        <Checkbox
                                                            checked={checkedState["სრულდება"] || false}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            onChange={(e) => handleCheckboxChange("სრულდება", e.target.checked)}
                                                            color="primary"
                                                        />)}
                                                </div>

                                            </th>
                                            {location.pathname === '/dashboard/expiring' && (
                                                <th style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer"
                                                }} onClick={() => handleSortChange('Dedline')}
                                                    title={"ნებართვის ვადა"}>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>
                                                            ნებართვის ვადა
                                                            {sortField === 'Dedline' ? (sortOrder ?
                                                                    <FaSortDown style={{marginLeft: 5}}/> :
                                                                    <FaSortUp style={{marginLeft: 5}}/>) :
                                                                <FaSort style={{marginLeft: 5}}/>}
                                                        </span>

                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["ნებართვის ვადა"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("ნებართვის ვადა", e.target.checked)}
                                                                color="primary"
                                                            />)}
                                                    </div>
                                                </th>
                                            )}
                                            {location.pathname === '/dashboard/expiring' && (
                                                <th style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer"
                                                }}
                                                    title={"პირობის ვადა"}>

                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>
                                                            პირობის ვადა
                                                        </span>

                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["პირობის ვადა"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("პირობის ვადა", e.target.checked)}
                                                                color="primary"
                                                            />)}

                                                    </div>

                                                </th>
                                            )}

                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                <th style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer"
                                                }}
                                                    title={"დოკუმენტაცია"}>
                                                    დოკუმენტაცია
                                                </th>
                                            )}
                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                <th style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer"
                                                }}
                                                    title={"ინსპეტირების დოკუმენტები"}>
                                                    ინსპექტირების დოკუმენტები
                                                </th>
                                            )}

                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                <th style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer"
                                                }}
                                                    title={"უწყებრივ რეესტრში რეგისტრაციის ნომერი"}>


                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}

                                                    >
                                                        <span>უწყებრივ რეესტრში რეგისტრაციის ნომერი</span>


                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["უწყებრივ რეესტრში რეგისტრაციის ნომერი"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("უწყებრივ რეესტრში რეგისტრაციის ნომერი", e.target.checked)}
                                                                color="primary"
                                                            />
                                                        )}

                                                    </div>

                                                </th>
                                            )}
                                            {inputTypes.length > 0 &&
                                                uniqueCaseDetailsKeys.filter(key => key === "ობიექტის მფლობელის დასახელება").map(key => (
                                                    <th onClick={() => handleSortChange(key)} key={key}>
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center'
                                                        }}>
                                                            <span>{key}</span>
                                                            {sortField === {key} ? (sortOrder ?
                                                                    <FaSortDown style={{marginLeft: 5}}/> :
                                                                    <FaSortUp style={{marginLeft: 5}}/>) :
                                                                <FaSort style={{marginLeft: 5}}/>}
                                                            {userRole && userRole !== "USER" && (
                                                                <Checkbox
                                                                    checked={checkedState[key] || false}
                                                                    onClick={e => e.stopPropagation()}
                                                                    onChange={e => handleCheckboxChange(key, e.target.checked)}
                                                                    color="primary"
                                                                />
                                                            )}
                                                        </div>
                                                    </th>
                                                ))
                                            }

                                            {location.pathname !== "/dashboard/objectregistrationtable" ? (
                                                <th
                                                    key={"განმცხადებელი"}
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }}
                                                    title={"განმცხადებელი"}>

                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>განმცხადებელი</span>
                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["განმცხადებელი"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("განმცხადებელი", e.target.checked)}
                                                                color="primary"
                                                            />
                                                        )}
                                                    </div>


                                                </th>
                                            ) : (
                                                <th key={"შექმნა"}
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }}
                                                    title={"შექმნა"}>

                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>შექმნა</span>
                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["შექმნა"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("შექმნა", e.target.checked)}
                                                                color="primary"
                                                            />
                                                        )}
                                                    </div>

                                                </th>)}

                                            <th
                                                key={"ობიექტი"}
                                                style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer"
                                                }}
                                                title={"ობიექტი"}>

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>ობიექტი</span>
                                                    {userRole && userRole !== "USER" && (
                                                        <Checkbox
                                                            checked={checkedState["ობიექტი"] || false}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            onChange={(e) => handleCheckboxChange("ობიექტი", e.target.checked)}
                                                            color="primary"
                                                        />
                                                    )}
                                                </div>


                                            </th>
                                            {isGeoDataInGeoArray("full_address") && (
                                                <th
                                                    key={"სრული მისამართი"}
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer",
                                                        width: 400
                                                    }}
                                                    title={"სრული მისამართი"}>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>სრული მისამართი</span>
                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["სრული მისამართი"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("სრული მისამართი", e.target.checked)}
                                                                color="primary"
                                                            />
                                                        )}
                                                    </div>
                                                </th>
                                            )}
                                            <th
                                                key={"მოთხოვნა"}
                                                style={{
                                                    textAlign: 'center',
                                                    fontFamily: "'FiraGO-SemiBold'",
                                                    fontSize: 14,
                                                    cursor: "pointer",
                                                    width: 400
                                                }}
                                                title={"მოთხოვნა"}>

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>მოთხოვნა</span>
                                                    {userRole && userRole !== "USER" && (
                                                        <Checkbox
                                                            checked={checkedState["მოთხოვნა"] || false}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            onChange={(e) => handleCheckboxChange("მოთხოვნა", e.target.checked)}
                                                            color="primary"
                                                        />
                                                    )}
                                                </div>


                                            </th>
                                            {isAgencyAnswers && (
                                                <th
                                                    key={"საკადასტრო კოდი"}
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer",
                                                        width: 400
                                                    }}
                                                    title={"საკადასტრო კოდი"}>

                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>საკადასტრო კოდი</span>
                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["საკადასტრო კოდი"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("საკადასტრო კოდი", e.target.checked)}
                                                                color="primary"
                                                            />
                                                        )}
                                                    </div>


                                                </th>
                                            )}


                                            {location.pathname !== "/dashboard/objectregistrationtable" && (
                                                <th
                                                    key={"სტატუსი"}
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }} onClick={() => handleSortChange('Status')}
                                                    title={"სტატუსი"}>

                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>სტატუსი
                                                            {sortField === 'Status' ? (sortOrder ?
                                                                    <FaSortDown style={{marginLeft: 5}}/> :
                                                                    <FaSortUp style={{marginLeft: 5}}/>) :
                                                                <FaSort style={{marginLeft: 5}}/>}
                                                        </span>
                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["სტატუსი"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("სტატუსი", e.target.checked)}
                                                                color="primary"
                                                            />
                                                        )}
                                                    </div>
                                                </th>
                                            )}
                                            {userRole !== 'USER' && userRole && (location.pathname !== "/agencyanswers") && (
                                                <th
                                                    key={"შემსრულებელი"}
                                                    style={{
                                                        textAlign: 'center',
                                                        fontFamily: "'FiraGO-SemiBold'",
                                                        fontSize: 14,
                                                        cursor: "pointer"
                                                    }}
                                                    title={"შემსრულებელი"}>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span>შემსრულებელი</span>

                                                        {userRole && userRole !== "USER" && (
                                                            <Checkbox
                                                                checked={checkedState["შემსრულებელი"] || false}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                onChange={(e) => handleCheckboxChange("შემსრულებელი", e.target.checked)}
                                                                color="primary"
                                                            />)}
                                                    </div>
                                                </th>
                                            )}


                                            {isTableExpanded &&
                                                (
                                                    <>
                                                        {location.pathname !== "/dashboard/objectregistrationtable" && (
                                                            <th
                                                                key={"ხარვეზის გამოსწორების თარიღი"}

                                                                title={"ხარვეზის გამოსწორების თარიღი"}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>ხარვეზის გამოსწორების თარიღი</span>
                                                                    {userRole && userRole !== "USER" && (
                                                                        <Checkbox
                                                                            checked={checkedState["ხარვეზის გამოსწორების თარიღი"] || false}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }}
                                                                            onChange={(e) => handleCheckboxChange("ხარვეზის გამოსწორების თარიღი", e.target.checked)}
                                                                            color="primary"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </th>
                                                        )}

                                                        {isGeoDataInGeoArray("region") && (
                                                            <th
                                                                key={"რეგიონი"}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    fontFamily: "'FiraGO-SemiBold'",
                                                                    fontSize: 14,
                                                                    cursor: "pointer"
                                                                }} onClick={() => handleSortChange('Region')}
                                                                title={"რეგიონი"}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>რეგიონი
                                                                        {sortField === 'Region' ? (sortOrder ?
                                                                                <FaSortDown style={{marginLeft: 5}}/> :
                                                                                <FaSortUp style={{marginLeft: 5}}/>) :
                                                                            <FaSort style={{marginLeft: 5}}/>}
                                                                    </span>
                                                                    {userRole && userRole !== "USER" && (
                                                                        <Checkbox
                                                                            checked={checkedState["რეგიონი"] || false}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }}
                                                                            onChange={(e) => handleCheckboxChange("რეგიონი", e.target.checked)}
                                                                            color="primary"
                                                                        />
                                                                    )}

                                                                </div>


                                                            </th>
                                                        )}
                                                        {isGeoDataInGeoArray("municipality") && (
                                                            <th
                                                                key={"მუნიციპალიტეტი"}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    fontFamily: "'FiraGO-SemiBold'",
                                                                    fontSize: 14,
                                                                    cursor: "pointer"
                                                                }} onClick={() => handleSortChange('City')}
                                                                title={"მუნიციპალიტეტი"}>

                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>
                                                                        მუნიციპალიტეტი
                                                                        {sortField === 'City' ? (sortOrder ?
                                                                                <FaSortDown style={{marginLeft: 5}}/>
                                                                                :
                                                                                <FaSortUp style={{marginLeft: 5}}/>) :
                                                                            <FaSort style={{marginLeft: 5}}/>}
                                                                    </span>
                                                                    {userRole && userRole !== "USER" && (
                                                                        <Checkbox
                                                                            checked={checkedState["მუნიციპალიტეტი"] || false}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }}
                                                                            onChange={(e) => handleCheckboxChange("მუნიციპალიტეტი", e.target.checked)}
                                                                            color="primary"
                                                                        />)}
                                                                </div>


                                                            </th>
                                                        )}
                                                        {isGeoDataInGeoArray("council") &&
                                                            (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") &&
                                                            (
                                                                <th
                                                                    key={"საკრებულო"}
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        fontFamily: "'FiraGO-SemiBold'",
                                                                        fontSize: 14,
                                                                        cursor: "pointer"
                                                                    }} onClick={() => handleSortChange('Council')}
                                                                    title={"საკრებულო"}>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                        <span>
                                                                            საკრებულო
                                                                            {sortField === 'Council' ? (sortOrder ?
                                                                                    <FaSortDown style={{marginLeft: 5}}/> :
                                                                                    <FaSortUp style={{marginLeft: 5}}/>) :
                                                                                <FaSort style={{marginLeft: 5}}/>}
                                                                        </span>
                                                                        {userRole && userRole !== "USER" && (
                                                                            <Checkbox
                                                                                checked={checkedState["საკრებულო"] || false}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                }}
                                                                                onChange={(e) => handleCheckboxChange("საკრებულო", e.target.checked)}
                                                                                color="primary"
                                                                            />
                                                                        )}
                                                                    </div>


                                                                </th>
                                                            )}
                                                        {isGeoDataInGeoArray("populated_area") &&
                                                            (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") &&
                                                            (
                                                                <th
                                                                    key={"დასახლებული პუნქტი"}
                                                                    onClick={() => handleSortChange('populatedArea')}
                                                                    title={"დასახლებული პუნქტი"}>

                                                                    <div style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                        <span>
                                                                            დასახლებული პუნქტი
                                                                            {sortField === 'populatedArea' ? (sortOrder ?
                                                                                    <FaSortDown style={{marginLeft: 5}}/> :
                                                                                    <FaSortUp style={{marginLeft: 5}}/>) :
                                                                                <FaSort style={{marginLeft: 5}}/>}
                                                                        </span>
                                                                        {userRole && userRole !== "USER" && (
                                                                            <Checkbox
                                                                                checked={checkedState["დასახლებული პუნქტი"] || false}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                }}
                                                                                onChange={(e) => handleCheckboxChange("დასახლებული პუნქტი", e.target.checked)}
                                                                                color="primary"
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </th>
                                                            )}


                                                        {userRole !== 'USER' &&
                                                            userRole &&
                                                            (location.pathname !== "/agencyanswers") &&
                                                            (
                                                                <th
                                                                    key={"შემსრულებლის პოზიცია"}

                                                                    title={"შემსრულებლის პოზიცია"}>

                                                                    <div style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                        <span>შემსრულებლის პოზიცია</span>
                                                                        {userRole && userRole !== "USER" && (
                                                                            <Checkbox
                                                                                checked={checkedState["შემსრულებლის პოზიცია"] || false}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                }}
                                                                                onChange={(e) => handleCheckboxChange("შემსრულებლის პოზიცია", e.target.checked)}
                                                                                color="primary"
                                                                            />
                                                                        )}
                                                                    </div>


                                                                </th>
                                                            )}

                                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                            <th
                                                                key={"გადამოწმების თარიღი"}

                                                                title={"გადამოწმების თარიღი"}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>გადამოწმების თარიღი</span>
                                                                    {userRole && userRole !== "USER" && (
                                                                        <Checkbox
                                                                            checked={checkedState["გადამოწმების თარიღი"] || false}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }}
                                                                            onChange={(e) => handleCheckboxChange("გადამოწმების თარიღი", e.target.checked)}
                                                                            color="primary"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </th>
                                                        )}

                                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                            <th
                                                                key={"მოქმედების ვადა"}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    fontFamily: "'FiraGO-SemiBold'",
                                                                    fontSize: 14,
                                                                    cursor: "pointer"
                                                                }}
                                                                title={"მოქმედების ვადა"}>

                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>მოქმედების ვადა</span>
                                                                    <Checkbox
                                                                        checked={checkedState["მოქმედების ვადა"] || false}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                        }}
                                                                        onChange={(e) => handleCheckboxChange("მოქმედების ვადა", e.target.checked)}
                                                                        color="primary"
                                                                    />
                                                                </div>
                                                            </th>
                                                        )}
                                                        {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (
                                                            <th
                                                                key={"შენიშვნა"}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    fontFamily: "'FiraGO-SemiBold'",
                                                                    fontSize: 14,
                                                                    cursor: "pointer"
                                                                }}
                                                                title={"შენიშვნა"}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>შენიშვნა</span>

                                                                    {userRole && userRole !== "USER" && (
                                                                        <Checkbox
                                                                            checked={checkedState["შენიშვნა"] || false}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }}
                                                                            onChange={(e) => handleCheckboxChange("შენიშვნა", e.target.checked)}
                                                                            color="primary"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </th>
                                                        )}

                                                        {inputTypes.length > 0 &&
                                                            uniqueCaseDetailsKeys.filter(key => key !== "ობიექტის მფლობელის დასახელება").map(key => (
                                                                <th key={key}>
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                        <span>{key}</span>
                                                                        {userRole && userRole !== "USER" && (
                                                                            <Checkbox
                                                                                checked={checkedState[key] || false}
                                                                                onClick={e => e.stopPropagation()}
                                                                                onChange={e => handleCheckboxChange(key, e.target.checked)}
                                                                                color="primary"
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </th>
                                                            ))
                                                        }

                                                        {(location.pathname === "/agencyanswers" || location.pathname === "/objectregistry" || location.pathname === "/dashboard/objectregistry") &&
                                                            (
                                                                <th title={"რუკაზე ნახვა"}
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        fontFamily: "'FiraGO-SemiBold'",
                                                                        fontSize: 14
                                                                    }}>რუკაზე ნახვა
                                                                </th>
                                                            )
                                                        }
                                                    </>
                                                )}

                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data.map((item) => {
                                            const shouldBlink = checkIfBlinkingNeeded(item.dedline, item.status);
                                            return (
                                                <tr
                                                    key={item.id}
                                                    className="case-table-row"
                                                    onClick={() => handleClick(item)}


                                                >
                                                    {userRole && userRole === "USER" && userId && userId !== item.requesterId && isAgencyAnswers ?
                                                        (
                                                            <td onClick={(e) => e.stopPropagation()}
                                                                className={"table-url small-column"}>
                                                                <Checkbox
                                                                    checked={selectedCases.some(c => c.caseId === item.id)}
                                                                    onChange={() => handleSelectCase(item, item.id, item.requesterId)}
                                                                />

                                                            </td>
                                                        ) : isAgencyAnswers && userRole && userRole === "USER" ? (
                                                            <td onClick={(e) => e.stopPropagation()}
                                                                className={"table-url small-column"}>

                                                            </td>
                                                        ) : null
                                                    }

                                                    {(location.pathname === "/objectregistry" || location.pathname === "/agencyanswers" || location.pathname === "/dashboard/agencyanswers") ? (
                                                        <td
                                                            title={item.caseNumber}
                                                            className={"table-url small-column"}>{item.caseNumber}</td>
                                                    ) : location.pathname === "/dashboard/admincases" ? (
                                                        <td
                                                            title={item.caseNumber}
                                                            className={"table-url small-column"}>{item.caseNumber}</td>
                                                    ) : userRole === 'ROOTADMIN' && userRole && (location.pathname === "/dashboard/hidecases") ? (
                                                            <td
                                                                title={item.caseNumber}
                                                                className={"table-centred-val small-column"}>{item.caseNumber}</td>
                                                        )
                                                        : (
                                                            <td
                                                                title={item.caseNumber}
                                                                className={"table-url small-column"}>
                                                                {item.caseNumber}
                                                            </td>
                                                        )}
                                                    {userRole === 'ROOTADMIN' && userRole && (location.pathname === "/dashboard/hidecases") && (
                                                        <td className={"table-centred-val-user small-column"}>
                                                            <Tooltip title={"განაცხადის წაშლა"}>
                                                                <div className="delete-case-icon"
                                                                     onClick={() => handleDeleteModal(item.id)}>

                                                                    <MdDelete/>
                                                                </div>
                                                            </Tooltip>
                                                        </td>
                                                    )}
                                                    {userRole === 'ROOTADMIN' && userRole && (location.pathname === "/dashboard/hidecases") && (
                                                        <td className={"table-centred-val-user"}>
                                                            <Tooltip title={"განაცხადის დამალვა"}>
                                                                <div className="delete-case-icon small-column"
                                                                     onClick={() => handleCaseVisibilityModal(item.id, item.isPublic)}>
                                                                    {item.isPublic ? (
                                                                        <>
                                                                            <Visibility
                                                                                className="shared-file-icon"/>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <VisibilityOff
                                                                                className="shared-file-icon"/>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </Tooltip>
                                                        </td>
                                                    )}
                                                    <td title={formatDate(item.createDate)}
                                                        className={"table-centred-val-date small-column "}>
                                                        {formatDate(item.createDate)}
                                                    </td>
                                                    <td title={formatDate(item.dedline)}
                                                        className={shouldBlink ? "blink-cell small-column" : "table-centred-val-date small-column"}>
                                                        {formatDate(item.dedline)}
                                                    </td>
                                                    {location.pathname === '/dashboard/expiring' && (
                                                        <td title={formatDate(item.termOfPermitDate)}
                                                            className={"table-centred-val small-column"}>
                                                            {formatDate(item.termOfPermitDate)}
                                                        </td>
                                                    )}
                                                    {location.pathname === '/dashboard/expiring' && (
                                                        <td title={formatDate(item.conditionDeadline)}
                                                            className={"table-centred-val small-column"}>
                                                            {formatDate(item.conditionDeadline)}
                                                        </td>
                                                    )}
                                                    {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && users.length !== 0 && (
                                                        <td onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenDialog(item.id, false, true);
                                                        }}
                                                            className={"table-centred-val small-column"}
                                                            style={{cursor: 'pointer'}}>
                                                            <Tooltip title={"დოკუმენტების ნახვა"}>
                                                                <div>
                                                                    <FaFileAlt size="20px"/>
                                                                </div>
                                                            </Tooltip>
                                                        </td>
                                                    )}
                                                    {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && users.length !== 0 && (
                                                        <td onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenDialog(item.id, true, false);
                                                        }}
                                                            className={"table-centred-val small-column"}
                                                            style={{cursor: 'pointer'}}>
                                                            <Tooltip title={"დოკუმენტების ნახვა"}>
                                                                <div>
                                                                    <FaFileAlt size="20px"/>
                                                                </div>
                                                            </Tooltip>
                                                        </td>
                                                    )}
                                                    {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && users.length !== 0 && (
                                                        <td
                                                            className={"table-centred-val small-column"}
                                                            style={{cursor: 'pointer'}}>
                                                            {item.objectRegistryID}
                                                        </td>
                                                    )}
                                                    {inputTypes.length > 0 &&
                                                        uniqueCaseDetailsKeys
                                                            .filter(key => key === "ობიექტის მფლობელის დასახელება")
                                                            .map(key => {
                                                                const detail = item.caseDetails.find(d => d.key === key);
                                                                return (
                                                                    <td key={key}>
                                                                        {detail ? detail.value : ''}
                                                                    </td>
                                                                );
                                                            })
                                                    }

                                                    <td title={item.requesterName}
                                                        className={"table-centred-val"}>
                                                        {item.requesterName}
                                                    </td>
                                                    {item.permitTypeTitle ? (
                                                        <td
                                                            title={item.permitTypeTitle}

                                                            className={"table-centred-val"}>
                                                            {item.permitTypeTitle}
                                                        </td>
                                                    ) : (
                                                        <td
                                                            title={findObjectTitleById(item.permitTypeId)}

                                                            className={"table-centred-val"}>
                                                            {findObjectTitleById(item.permitTypeId)}
                                                        </td>
                                                    )}

                                                    {isGeoDataInGeoArray("full_address") && (
                                                        <td title={formatGeoData(item).fullText}
                                                            className="table-centred-val-geodata ">
                                                            {formatGeoData(item).displayText}
                                                        </td>
                                                    )}
                                                    <td
                                                        title={item.request}
                                                        className={"table-centred-val small-column"}>
                                                        {item.request}
                                                    </td>
                                                    {isAgencyAnswers && (
                                                        <td
                                                            title={item.cadastralCode}
                                                            className="table-centred-val small-column"
                                                        >
                                                            {item.cadastralCode?.split("$").join(", ")}
                                                        </td>
                                                    )}


                                                    <td
                                                        className={"table-centred-val"}
                                                        title={userRole !== 'USER' ? findStatusTitleByIdForInternalUser(item.status, checkIfObjectIsInRegistery(objectsOfRegistery, item.permitTypeTitle)) : findStatusTitleById(item.status, checkIfObjectIsInRegistery(objectsOfRegistery, item.permitTypeTitle))}>{userRole !== 'USER' ? findStatusTitleByIdForInternalUser(item.status, checkIfObjectIsInRegistery(objectsOfRegistery, item.permitTypeTitle)) : findStatusTitleById(item.status, checkIfObjectIsInRegistery(objectsOfRegistery, item.permitTypeTitle))}
                                                    </td>
                                                    {userRole && userRole !== 'USER' && (location.pathname !== "/agencyanswers") && (
                                                        <td className={"table-centred-val-user"}
                                                            title={item.caseUserUsers && item.caseUserUsers.length > 0 ? `${item.caseUserUsers[0].firstName}  ${item.caseUserUsers[0].lastName}` : ''}>
                                                            {item.caseUserUsers && item.caseUserUsers.length > 0 ? `${item.caseUserUsers[0].firstName}  ${item.caseUserUsers[0].lastName}` : ''}
                                                        </td>
                                                    )}


                                                    {isTableExpanded && (
                                                        <>
                                                            <td
                                                                className={"table-centred-val-geodata small-column"}
                                                                title={
                                                                    formatDate(item.userFixDeclinationDate)
                                                                }
                                                            >
                                                                {formatDate(item.userFixDeclinationDate)}
                                                            </td>
                                                            {isGeoDataInGeoArray("region") && (
                                                                <td
                                                                    title={item.regionsNames}
                                                                    className={"table-centred-val small-column"}>
                                                                    {item.regionsNames}
                                                                </td>
                                                            )}
                                                            {isGeoDataInGeoArray("municipality") && (
                                                                <td
                                                                    title={item.citysNames}
                                                                    className={"table-centred-val small-column"}>
                                                                    {item.citysNames}
                                                                </td>
                                                            )}
                                                            {isGeoDataInGeoArray("council") && (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") && (
                                                                <td
                                                                    title={item.councilsNames}
                                                                    className={"table-centred-val small-column"}>
                                                                    {item.councilsNames}
                                                                </td>
                                                            )}
                                                            {isGeoDataInGeoArray("populated_area") && (location.pathname !== "/dashboard/registery" && location.pathname !== "/objectregistry") && (
                                                                <td
                                                                    title={item.populatedAreasNames}
                                                                    className={"table-centred-val small-column"}>
                                                                    {item.populatedAreasNames}
                                                                </td>
                                                            )}

                                                            {userRole && userRole !== 'USER' && (location.pathname !== "/agencyanswers") && (
                                                                <td className={"table-centred-val-user small-column"}
                                                                    title={item.caseUserUsers && item.caseUserUsers.length > 0 ? `(${rolesInGeorgian[item.caseUserUsers[0].role]})` : ''}>
                                                                    {item.caseUserUsers && item.caseUserUsers.length > 0 ? `${rolesInGeorgian[item.caseUserUsers[0].role]}` : ''}
                                                                </td>
                                                            )
                                                            }

                                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (

                                                                <td title={formatDate(item.inspectionDocumentmplementation)}
                                                                    className={"table-centred-val small-column"}>
                                                                    {formatDate(item.inspectionDocumentmplementation)}
                                                                </td>
                                                            )}
                                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (

                                                                <td title={formatDate(item.inspectionSertificatValidityPeriodDate)}
                                                                    className={"table-centred-val small-column"}>
                                                                    {formatDate(item.inspectionSertificatValidityPeriodDate)}
                                                                </td>
                                                            )}
                                                            {(location.pathname === "/dashboard/registery" || location.pathname === "/objectregistry") && (userRole && userRole !== "USER") && (

                                                                <td title={item.note}
                                                                    className={"table-centred-val small-column"}>
                                                                    {item.note}
                                                                </td>
                                                            )}

                                                            {inputTypes.length > 0 &&
                                                                uniqueCaseDetailsKeys
                                                                    .filter(key => key !== "ობიექტის მფლობელის დასახელება")
                                                                    .map(key => {
                                                                        const detail = item.caseDetails.find(d => d.key === key);
                                                                        return (
                                                                            <td key={key}>
                                                                                {detail ? detail.value : ''}
                                                                            </td>
                                                                        );
                                                                    })
                                                            }

                                                            {(location.pathname === "/agencyanswers" || location.pathname === "/objectregistry" || location.pathname === "/dashboard/objectregistry") &&
                                                                (
                                                                    <td
                                                                        title={item.caseNumber}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            window.open("/interactivemap?id=" + item.id.toString(), "_blank");
                                                                        }}

                                                                        className={"table-url small-column"}>
                                                                        <FaMapMarkedAlt
                                                                            style={{fontSize: 41}}/></td>
                                                                )}
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            <div className="case-table-pagination">

                                <div>
                                    <Pagination
                                        count={totalPages}
                                        page={page + 1}
                                        onChange={(event, value) => handlePageChange(value - 1)}
                                        showFirstButton
                                        showLastButton
                                        className="case-table-pagination"
                                    />
                                </div>
                                <div>
                                    <FormControl variant="standard" sx={{m: 1, minWidth: 120}}>
                                        <InputLabel id="page-size-select-label">მაჩვენე</InputLabel>
                                        <Select label={"მაჩვენე"} value={pageSize} onChange={handlePageSizeChange}
                                                className="case-table-select">
                                            {[10, 20, 30, 40, 50].map(size => (
                                                <MenuItem key={size} value={size}>
                                                    {size}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>


                            </div>
                        </div>
                    )
                }
            </div>
            <ConfirmationModal
                isOpen={isDeleteModalOpen}
                onRequestClose={() => setIsDeleteModalOpen(false)}
                onConfirm={deleteCase}
            />
            <ConfirmationModal
                isOpen={isCasePublicModalOn}
                onRequestClose={() => setIsCasePublicModalOn(false)}
                onConfirm={changeCaseVisibility}
            />
        </div>
    );
};

export default ObjectRegisteryTable;
